import React, { useEffect, useRef, useState } from 'react';
import { Radio, Form, Input, Button, Checkbox, Card, Space, Popconfirm, message, Spin, Select, Divider, InputNumber, Col, Row, Tag } from 'antd';
import constants from '../../../constants/constants';
import { fetchAdminApi, fetchApi } from '../../../services/api';
import { DOB } from '../../../globalFunctions/GlobalFunctions';
import { COOKIE, getCookie } from '../../../services/cookie';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { PlusOutlined } from '@ant-design/icons';
import EditableCheatSheet from '../CheatSheet/CheatSheet';
import { useHistory } from "react-router";
import TextArea from "antd/es/input/TextArea";
import PreAssess_Summary from '../CheatSheet/PreAssess_Summary';
import SpeechToTextButton from '../../component/SpeechToText';
const { Option } = Select;

// Custom components
const custom_select = (allowClear, placeholder, mode, options, onAdd, value, onChange, inputRef, style, onFieldChange, className, selectValue) => {
	return (
		<Select
			allowClear={allowClear}
			placeholder={placeholder}
			mode={mode}
			style={style}
			onChange={onFieldChange}
			className={className}
			value={selectValue}
			dropdownRender={(menu) => (
				<>
					{menu}
					<Divider style={{ margin: '8px 0' }} />
					<Space style={{ padding: '0 8px 4px' }}>
						<Input
							placeholder="Please enter option."
							ref={inputRef}
							value={value}
							onChange={onChange}
							onKeyDown={(e) => e.stopPropagation()}
						/>
						<Button type="text" icon={<PlusOutlined />} onClick={onAdd}>
							Add
						</Button>
					</Space>
				</>
			)}
			options={options
				.slice()
				.sort((a, b) => a.localeCompare(b))
				.map((item) => ({
					label: item,
					value: item,
				}))}
		/>
	);
};

const custom_radio = (name, question, yesValue, noValue, RequiredField = false) => {
	return (
		<Form.Item
			name={name}
			className={`mb-3`}
			rules={[{ required: RequiredField, message: constants.RequiredField }]}
			label={<span className="text-red-800 text-sm font-bold">{question}</span>}
		>
			<Radio.Group>
				<Radio value={yesValue}>{constants.Yes}</Radio>
				<Radio value={noValue}>{constants.No}</Radio>
			</Radio.Group>
		</Form.Item>
	);
};

const AddNote = (props) => {
	const [form] = Form.useForm();
	const history = useHistory();
	const loginType = getCookie(COOKIE.LoginType);
	const adminClientValuefromSession = JSON.parse(sessionStorage.getItem("adminClientValue"));
	const [loader, setLoader] = useState(false);
	const adminEnquiryValuefromSession = JSON.parse(sessionStorage.getItem("enquiryDetails"))
	const [enquiryClientDetails, setEnquiryClientDetails] = useState(JSON.parse(sessionStorage.getItem("enquiryDetails")) || []);
	const [pronoun, setPronoun] = useState("She/He");
	const [possPronoun, setPossPronoun] = useState("His/Her");
	const [beVerb, setBeVerb] = useState("is");
	const [past, setPast] = useState("s");
	// Notes
	const [noteValue, setNoteValue] = useState(null);
	const [noteTypeValue, setNoteTypeValue] = useState("0");
	const [sessionChecked, setSessionChecked] = useState(false);
	const [isNoteAnswered, setIsNoteAnswered] = useState(false);
	const [notefollowUp, setNoteFollowUp] = useState(false);
	const notesHeader = ["DATA:", "ASSESSMENT:", "PLAN:"];
	// Field state changes
	const [isDrug1Selected, setIsDrug1Selected] = useState(false);
	const [isDrug4Selected, setIsDrug4Selected] = useState(false);
	const [isFamily1Selected, setIsFamily1Selected] = useState(null);
	const [isFamily6Selected, setIsFamily6Selected] = useState(null);
	const [isFamily8Selected, setIsFamily8Selected] = useState(false);
	const [isFamily11Selected, setIsFamily11Selected] = useState(false);
	const [isFamily14Selected, setIsFamily14Selected] = useState(false);
	const [isEmotional1Selected, setIsEmotional1Selected] = useState(false);
	const [isEmotional9Selected, setIsEmotional9Selected] = useState(false);
	const [isEmotional10Selected, setIsEmotional10Selected] = useState(false);
	const [isEmotional11Selected, setIsEmotional11Selected] = useState(false);
	const [isEmotional12Selected, setIsEmotional12Selected] = useState(false);
	const [isMedical4Selected, setIsMedical4Selected] = useState(false);
	const [isMedical6Selected, setIsMedical6Selected] = useState(false);
	const [isMedical8Selected, setIsMedical8Selected] = useState(false);
	const [selectedSubstances, setSelectedSubstances] = useState({});
	const [selectedReasons, setSelectedReasons] = useState({});
	const [selectedAttempts, setSelectedAttempts] = useState({});
	const [selectedMentalHealthOption, setSelectedMentalHealthOption] = useState([]);
	const [showEducationDetails, setShowEducationDetails] = useState(false);
	const [isSelectedDisorderes, setIsSelectedDisorderes] = useState(false);
	const [selectedDiagnosisType, setSelectedDiagnosisType] = useState(null);
	const [diagnosisData, setDiagnosisData] = useState({});
	const [assessmentBehavior, setAssessmentBehavior] = useState([]);
	const [activeEditorIndex, setActiveEditorIndex] = useState(null);
	const [planValue, setPlanValue] = useState(null);
	const [isPlanSelected, setIsPlanSelected] = useState(false);

	// Select Options
	// const [listAssociates, setListAssociates] = useState([]);
	const [maritalStatus, setMaritalStatus] = useState(['Single', 'Divorced', 'Married']);
	const [newMaritalStatus, setNewMaritalStatus] = useState('');
	const maritalStatusInputRef = useRef(null);
	const addMaritalStatus = () => {
		if (!newMaritalStatus) return;
		setMaritalStatus([...maritalStatus, newMaritalStatus]);
		setNewMaritalStatus('');
		setTimeout(() => maritalStatusInputRef.current?.focus(), 0);
	};
	const [ethnicity, setEthnicity] = useState(constants.EthnicityList);
	const [newEthnicity, setNewEthnicity] = useState('');
	const ethnicityInputRef = useRef(null);
	const addEthnicity = () => {
		if (!newEthnicity) return;
		setEthnicity([...ethnicity, newEthnicity]);
		setNewEthnicity('');
		setTimeout(() => ethnicityInputRef.current?.focus(), 0);
	};
	const [religion, setReligion] = useState(constants.ReligionList);
	const [newReligion, setNewReligion] = useState('');
	const religionInputRef = useRef(null);
	const addReligion = () => {
		if (!newReligion) return;
		setReligion([...religion, newReligion]);
		setNewReligion('');
		setTimeout(() => religionInputRef.current?.focus(), 0);
	};
	const [assessment, setAssessment] = useState(['CAGE', 'MMMH']);
	const [newAssessment, setNewAssessment] = useState('');
	const assessmentInputRef = useRef(null);
	const addAssessment = () => {
		if (!newAssessment) return;
		setAssessment([...assessment, newAssessment]);
		setNewAssessment('');
		setTimeout(() => assessmentInputRef.current?.focus(), 0);
	};
	const [disorder, setDisorder] = useState(constants.DisorderOption);
	const [newDisorder, setNewDisorder] = useState('');
	const disorderInputRef = useRef(null);
	const addDisorder = () => {
		if (!newDisorder) return;
		setDisorder([...disorder, newDisorder]);
		setNewDisorder('');
		setTimeout(() => disorderInputRef.current?.focus(), 0);
	};
	const sortByLabelSafe = (options) =>
		Array.isArray(options)
			? [...options].sort((a, b) => (a.label || '').localeCompare(b.label || ''))
			: [];

	const diagnosisTypeMap = {
		'Primary Addiction Diagnosis': {
			name: 'primary_diagnosis',
			options: sortByLabelSafe(constants.primarySecondaryTertiaryOptions)
		},
		'Secondary Addiction Diagnosis': {
			name: 'secondary_diagnosis',
			options: sortByLabelSafe(constants.primarySecondaryTertiaryOptions)
		},
		'Tertiary Addiction Diagnosis': {
			name: 'tertiary_diagnosis',
			options: sortByLabelSafe(constants.primarySecondaryTertiaryOptions)
		},
		'Primary Mental Diagnosis': {
			name: 'other_cd_diagnosis',
			options: sortByLabelSafe(constants.mentalHealthDiagOptions)
		},
		'Secondary Mental Diagnosis': {
			name: 'mental_health_diagnosis_2',
			options: sortByLabelSafe(constants.mentalHealthDiagOptions)
		},
		'Tertiary Mental Diagnosis': {
			name: 'mental_health_diagnosis_3',
			options: sortByLabelSafe(constants.mentalHealthDiagOptions)
		},
		'Primary Other Diagnosis': {
			name: 'other_diagnosis_1',
			options: sortByLabelSafe(constants.Otheroptions)
		},
		'Secondary Other Diagnosis': {
			name: 'other_diagnosis_2',
			options: sortByLabelSafe(constants.Otheroptions)
		},
		'Tertiary Other Diagnosis': {
			name: 'other_diagnosis_3',
			options: sortByLabelSafe(constants.Otheroptions)
		}
	};

	// disorder declarations end
	const [angerDeppressed, setAngerDepressed] = useState(['Adjustment disorders with Depressed Mood', 'Adjustment disorders with Anxiety', 'Adjustment disorders with Mixed Anxiety and Depressed Mood', 'Adjustment disorders (Unspecified)', 'Parent Child Conflict', 'Partner Relational Conflict']);
	const [newAngerDeppressed, setNewAngerDeppressed] = useState('');
	const angerDeppressedInputRef = useRef(null);
	const addAngerDeppressed = () => {
		if (!newDisorder) return;
		setAngerDepressed([...disorder, newDisorder]);
		setNewAngerDeppressed('');
		setTimeout(() => disorderInputRef.current?.focus(), 0);
	};
	const [birthOrder, setBirthOrder] = useState(['oldest', 'youngest', 'only', 'middle child']);
	const [newBirthOrder, setNewBirthOrder] = useState('');
	const birthOrderInputRef = useRef(null);
	const addBirthOrder = () => {
		if (!newBirthOrder) return;
		setBirthOrder([...birthOrder, newBirthOrder]);
		setNewBirthOrder('');
		setTimeout(() => birthOrderInputRef.current?.focus(), 0);
	};
	const [living, setLiving] = useState(constants.LivingCondition);
	const [newLiving, setNewLiving] = useState('');
	const livingInputRef = useRef(null);
	const addLiving = () => {
		if (!newLiving) return;
		setLiving([...living, newLiving]);
		setNewLiving('');
		setTimeout(() => livingInputRef.current?.focus(), 0);
	};
	const [identity, setIdentity] = useState(['Heterosexual', 'Bisexual']);
	const [newIdentity, setNewIdentity] = useState('');
	const identityInputRef = useRef(null);
	const addIdentity = () => {
		if (!newIdentity) return;
		setIdentity([...identity, newIdentity]);
		setNewIdentity('');
		setTimeout(() => identityInputRef.current?.focus(), 0);
	};
	const [mentalD, setMentalD] = useState(constants.MentalHealth);
	const [newMentalD, setNewMentalD] = useState('');
	const mentalDInputRef = useRef(null);
	const addMentalD = () => {
		if (!newMentalD) return;
		setMentalD([...mentalD, newMentalD]);
		setNewMentalD('');
		setTimeout(() => mentalDInputRef.current?.focus(), 0);
	};
	const [symptoms, setSymptoms] = useState(['severe distress like negative impact on work, home and social life', 'loss of interest in activities', 'problems sleeping', 'loss of appetite', 'sadness', 'hopelessness', 'headaches', 'gastrointestinal problems', 'panic attacks', 'heart palpitations', 'cold sweats', 'worry', 'fatigue', 'nervousness']);
	const [newSymptoms, setNewSymptoms] = useState('');
	const symptomsInputRef = useRef(null);
	const addSymptoms = () => {
		if (!newSymptoms) return;
		setSymptoms([...symptoms, newSymptoms]);
		setNewSymptoms('');
		setTimeout(() => symptomsInputRef.current?.focus(), 0);
	};
	const attempts = [
		"cut down use of substances/gambling",
		"feeling angry if spoken to about use",
		"feeling guilty about use",
		"having used substances/gambled early morning in order to start the day",
	];

	// Date of notes
	const current = new Date();
	const isEdit = props?.path === "/edit-note" || props?.path === "/edit-pre-assessment-intake" || props?.path === "/edit-self-assessment-summary"
	const [noteDate, setNoteDate] = useState({
		date: isEdit ? null : current.getDate(),
		month: isEdit ? null : (current.getMonth() + 1).toString().padStart(2, '0'),
		year: isEdit ? null : current.getFullYear()
	});
	const handleNoteDayChange = (value) => {
		setNoteDate({
			...noteDate,
			date: value
		});
	};
	const handleNoteMonthChange = (value) => {
		setNoteDate({
			...noteDate,
			month: value
		});
	};
	const handleNoteYearChange = (value) => {
		setNoteDate({
			...noteDate,
			year: value
		});
	};

	useEffect(() => {
		const notesType =
			props?.location?.state?.notes_type || noteTypeValue;

		getForm(notesType);

		const clientId = adminClientValuefromSession?.clientId;
		const enquiryIdFromSession = adminClientValuefromSession?.enquiryId;
		const enquiryIdFromAdmin = adminEnquiryValuefromSession?.enquiry_id;

		if (clientId) {
			fetchClientDetails(clientId);
		} else {
			if (props?.path === "/pre-assessment-intake" || props?.path === "/edit-pre-assessment-intake") {
				fetchEnquiryDetails(enquiryIdFromAdmin);
			} else if (props?.path !== "/self-assessment-summary") {
				fetchEnquiryDetails(enquiryIdFromSession);
			}
		}
		// getListAssociates();
	}, []);

	useEffect(() => {
		setFormFields(props && props.location && props.location.state && props.location.state.answers ? props.location.state.answers : null);
		setSessionChecked(props?.location?.state?.session);
		setNoteFollowUp(props?.location?.state?.answers?.follow_up)
		if (props?.location?.state?.answers?.patient_problem) {
			setNoteTypeValue(props?.location?.state?.answers?.patient_problem)
		}
	}, []);

	useEffect(() => {
		const isEdit = props?.path === "/edit-note" || props?.path === "/edit-pre-assessment-intake" || props?.path === "/edit-self-assessment-summary"
		const existingDate = props?.location?.state?.date_of_notes;

		if (isEdit && existingDate) {
			const [year, month, day] = existingDate.split("-");
			setNoteDate({
				date: parseInt(day),
				month: month,
				year: parseInt(year)
			});
		}
	}, []);

	const getForm = (formType) => {
		setNoteTypeValue(formType);
		if (formType === "0" || formType === "8") {
			// Update note values for displaying in the editor
			setNoteValue([
				props.location.state?.notes_content || "",
				props.location.state?.notes_assesment || "",
				props.location.state?.notes_plan || ""
			]);
		} else {
			setNoteValue(["", "", ""]);
		}
		setFormFields(props && props.location && props.location.state && props.location.state.answers ? props.location.state.answers : null);
	};

	// Filter out any legacy array entries
	const isLegacyEntry = (key, val) =>
		Array.isArray(val) && val.length === 3 && typeof val[0] === 'string' && typeof val[2] === 'string';

	const setFormFields = (userans = null) => {
		if (userans !== null) {
			const raw = userans?.new_assesment_disorder || {};
			const cleanedDiagnosisData = Object.entries(raw).reduce((acc, [key, val]) => {
				if (!isNaN(Number(key))) {
					return acc;
				}
				if (isLegacyEntry(key, val)) {
					return acc;
				}
				if (Array.isArray(val) && val.length > 0) {
					acc[key] = val;
				}
				return acc;
			}, {});

			handlePronounChange(userans?.gender);
			form.setFieldsValue(userans);
			setSelectedReasons(userans?.selectedreasons || {});
			setNoteFollowUp(userans?.follow_up);
			setSelectedSubstances(userans?.selectedsubstances || {});
			setSelectedAttempts(userans?.selectedattempts || {});
			setSelectedMentalHealthOption(userans?.mentalhealthoption || []);
			setDiagnosisData(cleanedDiagnosisData);
			setIsEmotional1Selected(userans?.emotional_1 === "denies");
			setIsEmotional10Selected(userans?.emotional_10 === "never received");
			setIsEmotional11Selected(userans?.emotional_11 === "was not");
			setIsEmotional12Selected(userans?.emotional_12 === "no medications");
			setIsEmotional9Selected(userans?.emotional_9 === "denies");
			setIsDrug1Selected(userans?.drug_1 === 'denies any');
			setIsDrug4Selected(userans?.drug_4 === 'never been');
			setIsFamily1Selected(userans?.family_1 === 'only');
			setIsFamily6Selected(userans?.family_6 === "has no");
			setIsFamily8Selected(userans?.family_8 === 'current');
			setIsFamily11Selected(userans?.family_11 === "works as a");
			setIsFamily14Selected(userans?.family_14 === "does no");
			setIsMedical4Selected(userans?.medical_4 === "Allergies");
			setIsMedical6Selected(userans?.medical_6 === "illnesses/disease" || userans?.medical_7);
			setIsMedical8Selected(userans?.medical_8 === "medications/OTCs");
			setIsSelectedDisorderes(!!userans?.assesment_disorder?.length);
			setAssessmentBehavior(userans?.assessment_behavior);
			setPlanValue(userans?.plan_option);
			setIsPlanSelected(false);
			if (userans?.medical_7) form.setFieldsValue({ medical_6: 'illnesses/disease' });
		} else {
			let type_source = adminClientValuefromSession?.clientId ? enquiryClientDetails?.enquiry_info : enquiryClientDetails;
			const sourceOption = constants.SourceOption?.find(
				(option) => option.value === String(type_source?.source)
			);
			const sourceLabel = type_source?.source === "8" || type_source?.source === "9" ? type_source?.source_details : sourceOption?.label;
			form.setFieldsValue({
				first_name: enquiryClientDetails?.client_firstname,
				age: enquiryClientDetails?.age,
				location: enquiryClientDetails?.city + ", " + enquiryClientDetails?.region_name + ", " + enquiryClientDetails?.country_name,
				gender: enquiryClientDetails?.gender,
				source: sourceLabel,
			});
		}
	}

	// Fetching enquiry data
	const fetchEnquiryDetails = (enquiry_id) => {
		setLoader(true);
		let payload = { enquiry_id: enquiry_id };
		fetchApi(`/get-enquiry`, "post", payload)
			.then((res) => {
				if (res?.data) {
					setEnquiryClientDetails(res.data);
					sessionStorage.setItem("enquiryDetails", JSON.stringify(res?.data));
					setIsNoteAnswered(res?.data?.is_note_answered === 1);
				} else {
					message.error(res.message);
					setEnquiryClientDetails({});
				}
			})
			.catch(() => {
				message.error("Failed to fetch enquiry details");
				setEnquiryClientDetails({});
			})
			.finally(() => {
				setLoader(false);
			});
	};

	// Fetching client data
	const fetchClientDetails = (clientId) => {
		setLoader(true);
		fetchAdminApi(`/client-profile/${clientId}`, "get")
			.then((res) => {
				if (res?.data) {
					setEnquiryClientDetails(res.data);
					// const gender = res?.data?.gender?.toLowerCase();
					// handlePronounChange(gender);
					setIsNoteAnswered(res?.data?.is_note_answered === 1);
				} else {
					setEnquiryClientDetails([]);
				}
			})
			.catch(() => {
				message.error("Failed to fetch client details");
				setEnquiryClientDetails([]);
			})
			.finally(() => {
				setLoader(false);
			});
	};

	const handlePronounChange = (value) => {
		if (value) {
			const gender = value?.toLowerCase();
			if (gender === "male") {
				setPronoun("He")
				setPossPronoun("His")
				setBeVerb("is")
				setPast("s")
			} else if (gender === "female") {
				setPronoun("She");
				setPossPronoun("Her")
				setBeVerb("is")
				setPast("s")
			} else {
				setPronoun("They");
				setPossPronoun("Their")
				setBeVerb("are")
				setPast("")
			}
		} else {
			setPronoun("She/He")
			setPossPronoun("His/Her")
			setBeVerb("is")
			setPast("")
		}
	}

	const lowPronoun = pronoun.toLowerCase();
	const lowPossPronoun = possPronoun.toLowerCase();

	const hideModal = () => {
		history.push({ pathname: '/notes' });
	};
	const onchangeNoteValue = (e, index) => {
		setNoteValue(prev => {
			const updated = [...prev];
			updated[index] = e;
			return updated;
		});
	};
	const onFollowUpChange = (checked) => {
		setNoteFollowUp(checked);
		const firstName = enquiryClientDetails?.client_firstname;

		if (checked) {
			onchangeNoteValue(constants.FollowUpData1 + `${firstName || "Client"}` + constants.FollowUpData2, 0);
			onchangeNoteValue(constants.FollowUpAssessment, 1);
			onchangeNoteValue(constants.FollowUpPlan, 2);
		} else {
			onchangeNoteValue("", 0);
			onchangeNoteValue("", 1);
			onchangeNoteValue("", 2);
		}
	};
	const onSessionChange = (value) => {
		setSessionChecked(value);
	}
	// const getListAssociates = () => {
	// 	fetchAdminApi(`/view-associates`, "post").then((res) => {
	// 		if (res?.data) {
	// 			const firstItem = res?.data?.filter(obj => obj?.client_id === "1")[0];
	// 			const remainingItems = res?.data?.filter(obj => obj?.client_id !== "1");
	// 			let sortedData;
	// 			if (firstItem) {
	// 				sortedData = [firstItem, ...remainingItems];
	// 			} else {
	// 				sortedData = remainingItems
	// 			}
	// 			setListAssociates(sortedData);
	// 		}
	// 		else {
	// 			setListAssociates([]);
	// 		}
	// 	});
	// }
	// const selectFilterOption = (input, option) => {
	// 	return option.props.children.toLowerCase().indexOf(input.toLowerCase()) > -1 && option.props.children.toLowerCase().indexOf(input.toLowerCase()) < 1;
	// };

	const createNote = (value, type = null, assessmentType = null, onSubmitComplete) => {
		let userAnswerValue = value || {};
		if (assessmentType === null) {
			setLoader(true);
			if (noteTypeValue !== "0" || noteTypeValue !== "8") {
				if (selectedReasons) userAnswerValue.selectedreasons = selectedReasons;
				if (selectedSubstances) userAnswerValue.selectedsubstances = selectedSubstances;
				if (selectedAttempts) userAnswerValue.selectedattempts = selectedAttempts;
				if (notefollowUp) userAnswerValue.follow_up = notefollowUp ? 1 : 0;
			}
		}
		let s_substance = assessmentType === null ? selectedSubstances : value?.selectedsubstances;
		let s_attempts = assessmentType === null ? selectedAttempts : value?.selectedattempts;
		let s_reasons = assessmentType === null ? selectedReasons : value?.selectedreasons;
		let n_type = assessmentType === null ? noteTypeValue : value?.patient_problem;
		const formValues = {
			patient_problem: value?.patient_problem,
			birthdate: value?.birthdate,
			first_name: value?.first_name || "_________",
			last_name: value?.last_name,
			assesment_disorder: value?.assesment_disorder && value?.assesment_disorder?.length > 0 ? value?.assesment_disorder?.join(", ") : "",
			age: value?.age || "____",
			gender: value?.gender || "male/female",
			gender_details: value?.gender_details || "",
			location: value?.location || "______________",
			source: value?.source || "______________",
			// assignto: value?.assignto || "_________",
			source_details: value?.source_details || "",
			plan_1: value?.plan_1 || "await the appointment/consider options",
			plan_2: value?.plan_2 && value?.plan_2?.length > 0 ? value?.plan_2?.join(", ") : `complete a medical or wellness checkup/detox/have a Psych assessment with Dr. Ashish Deshpande/sign and complete the Coaching Agreement and Payment process`,
			presenting_problem_detail: value?.presenting_problem_detail,
			presenting_problem_text: value?.presenting_problem_text,
			assess_1: value?.assess_1 || "ambivalent/motivated",
			assess_2: value?.assess_2 && value?.assess_2?.length > 0 ? value?.assess_2?.join(", ") : "CAGE/MMMH",
			assess_3: value?.assess_3 || "appears/does not appear",
			assess_4: value?.assess_4 || "appropriate/not appropriate",
			assess_5: value?.assess_5 || "",
			intro_1: value?.intro_1 || "single/divorced/married",
			intro_2: value?.intro_2 || "Asian Indian/White/Black/Hispanic",
			intro_3: value?.intro_3 || "Hindu/Muslim/Christian/Buddhist/Jewish _________ (other)",
			addiction_1: value?.addiction_1 || "denied/reported",
			addiction_2: value?.addiction_2 || "Denies/Reports",
			addiction_3: value?.addiction_3 && value?.addiction_3?.length > 0 && value?.addiction_3?.join(", "),
			drug_1: value?.drug_1 || "denies/reports",
			drug_2: value?.drug_2 && value?.drug_2?.length > 0 ? value?.drug_2?.join(", ") : `□ has felt the need to bet more and more money, and has □ lied to people about how much ${lowPronoun} gamble${past}`,
			drug_3: value?.drug_3 || "Denies/Reports",
			drug_4: value?.drug_4 || "",
			drug_5: value?.drug_5 || "",
			drug_6: value?.drug_6 || "",
			drug_7: value?.drug_7 || "",
			drug_8: value?.drug_8 || "",
			drug_9: value?.drug_9 || "",
			drug_12: value?.drug_12 || "",
			drug_10: value?.drug_10 || "_________",
			drug_11: value?.drug_11 && value?.drug_11?.length > 0 ? value?.drug_11?.join(", ") : "substance use/gambling",
			problem_1: value?.problem_1 || "online/in-person",
			problem_2: value?.problem_2 || "_________",
			problem_3: value?.problem_3 || "_________",
			emotional_1: value?.emotional_1 || "denies/reports",
			emotional_2: value?.emotional_2 || "",
			emotional_3: value?.emotional_3 || "",
			emotional_4: value?.emotional_4 || "_________",
			emotional_5: value?.emotional_5 || "",
			emotional_6: value?.emotional_6 || "_________ (details)",
			emotional_7: value?.emotional_7 || "_________",
			emotional_8: value?.emotional_8 && value?.emotional_8?.length > 0 ? value?.emotional_8?.join(", ") : "severe distress like negative impact on work, home and social life; loss of interest in activities; problems sleeping, loss of appetite, sadness, hopelessness, headaches, gastrointestinal problems, panic attacks, heart palpitations, cold sweats, worry, fatigue and nervousness",
			emotional_9: value?.emotional_9 || "denies/reports",
			emotional_10: value?.emotional_10 || "",
			emotional_11: value?.emotional_11 || "",
			emotional_12: value?.emotional_12 || "",
			medical_1: value?.medical_1 || "Heterosexual/Bisexual/LGBTQ",
			medical_2: value?.medical_2 || "",
			medical_3: value?.medical_3 || "",
			medical_4: value?.medical_4 || "",
			medical_5: value?.medical_5 || "",
			medical_6: value?.medical_6 || "",
			medical_7: value?.medical_7 || "",
			medical_8: value?.medical_8 || "",
			medical_9: value?.medical_9 || "",
			medical_10: value?.medical_10 && value?.medical_10.length > 0 ? Array.isArray(value.medical_10) ? value.medical_10.join(" and ") : value.medical_10 : constants.DietaryHabbitsPlaceHolder,
			family_1: value?.family_1 || "_________",
			family_2: value?.family_2 || "____",
			family_3: value?.family_3 || "□living alone □with spouse/partner and children □ in traditional joint family with partner and parents and siblings",
			family_4: value?.family_4 || "fair/good/poor",
			family_5: value?.family_5 || "",
			family_6: value?.family_6 || "has/has no",
			family_7: value?.family_7 || "_________",
			family_8: value?.family_8 || "no/current",
			family_9: value?.family_9 || "_________",
			family_10: value?.family_10 || "______________ (Education)",
			education_details: value?.education_details,
			family_11: value?.family_11 || "is unemployed/retired/owns business/works as a _________",
			family_12: value?.family_12 || "______________",
			exercise: value?.excercise,
			family_13: value?.family_13 || "active/inactive",
			family_14: value?.family_14 || "does/does no",
			family_15: value?.family_15 || "",
			children_name: value?.children_name,
			spouse_name: value?.spouse_name || '',
			parent_name: value?.parent_name,
			reason: value?.reason,
			other_reasonforcall: value?.other_reasonforcall,
			email: value?.email,
			client_contact_number: value?.client_contact_number,
			address: value?.address,
			Apt: value?.Apt,
			pincode: value?.pincode,
			sexula_orientation: value?.sexula_orientation,
			is_signed_consentform: value?.is_signed_consentform,
			emergency_contact_name: value?.emergency_contact_name,
			relation_to_recipient: value?.relation_to_recipient,
			presenting_problem_options: value?.presenting_problem_options,
			orientation_to_change: value?.orientation_to_change,
			otherhealth: value?.otherhealth || "",
			hospital_details: value?.hospital_details || "",
			family_mental_health: value?.family_mental_health || "",
			family_mental_health_details: value?.family_mental_health_details || '',
			service: value?.service || "",
			family_substance: value?.family_substance || "",
			family_substance_details: value?.family_substance_details || "",
			type_gambling: value?.type_gambling || "",
			last_checkup_status: value?.last_checkup_status || "",
			selected_illnesses: value?.selected_illnesses || "",
			other_illness: value?.other_illness || "",
			other_major_health_detail: value?.other_major_health_detail || "",
			mentalhealthoption: value?.mentalhealthoption || "",
			substance_treat: value?.substance_treat,
		};

		const selectedLabels = (constants.PatientProblems || [])
			.filter(problem => formValues?.presenting_problem_options?.includes(problem.value))
			.map(problem => problem.label);

		const EXCLUDED_AGE_KEYS = ["not_applicable", "social_use", "religious_use", "social_gambling", "no_gambling"];
		const GAMBLING_KEYS = ["gambling", "social_gambling", "no_gambling"];
		const EXCLUDED_KEYS_FOR_AGE = ["not_applicable", "other", "social_use", "religious_use", "social_gambling", "no_gambling"];

		const selectOptions = constants.Substances
			.filter((s) => !EXCLUDED_KEYS_FOR_AGE.includes(s.key))
			.flatMap((s) => {
				if (s.key === "nicotine_vapes" && s.nicotineOptions) {
					// Add nicotine sub-options
					return s.nicotineOptions.map((opt) => ({
						value: `${s.key}_${opt.value}`, // e.g., nicotine_vapes_smoking
						label: `${s.substances} - ${opt.label}`, // e.g., Nicotine/Vapes - Smoking
					}));
				}
				return {
					value: s.key,
					label: s.substances,
				};
			});

		const getSelfAssessmentSentencefromPreAssess = (questionName, value) => {
			const question = constants.QuestionsPreAssessment.find(q => q.name === questionName);
			return question?.responses?.[value] || "";
		};

		const drugsPayload = (() => {
			const checkedSubstances = s_substance && typeof s_substance === "object" ?
				Object.entries(s_substance).filter(([, value]) => value.checked) : [];

			if (checkedSubstances?.length === 0) return "";

			// Create a map for quick lookup of checked substances
			const checkedMap = new Map(checkedSubstances);

			// Split substances into gambling and non-gambling, maintaining original order
			const nonGamblingSubstances = [];
			const gamblingSubstances = [];

			constants.Substances?.forEach(substanceInfo => {
				if (checkedMap?.has(substanceInfo.key)) {
					const value = checkedMap?.get(substanceInfo.key);
					const entry = [substanceInfo.key, value];

					if (GAMBLING_KEYS.includes(substanceInfo.key)) {
						gamblingSubstances.push(entry);
					} else {
						nonGamblingSubstances.push(entry);
					}
				}
			});

			// Combine non-gambling first, then gambling
			const orderedSubstances = [...nonGamblingSubstances, ...gamblingSubstances];

			return orderedSubstances?.map(([substance, value]) => {
				const substanceInfo = constants.Substances?.find(s => s.key === substance);
				let output = "";

				// Skip 'at age' for excluded keys
				const displayAge = !EXCLUDED_AGE_KEYS.includes(substance) ? ` at age ${value?.age || "_____"}` : "";

				// Special case: "other"
				if (substance === "other") {
					const otherText = value.textValue || "_____";
					return `<h3><b>Other:</b> ${otherText}</h3>`;
				}

				// Special case: Gambling
				if (substance === "gambling") {
					const children = Object.entries(value)
						.filter(([key, val]) => typeof val === "object" && val?.checked)
						.map(([childKey, childVal]) => {
							const match = substanceInfo?.gamblingOptions.find(opt => opt?.value === childKey);
							if (assessmentType !== 1) {
								if (match) {
									const sentence = childVal?.checked ? match.yes : match.no;
									return `<li><h3>The client ${sentence}</h3></li>`;
								}
							}
							return null;
						})
						.filter(Boolean);

					if (formValues?.type_gambling || value?.textValue) {
						const typeGamblingArray = Array.isArray(formValues?.type_gambling)
							? formValues.type_gambling
							: (formValues?.type_gambling ? [formValues.type_gambling] : []);

						children?.push(`<div><b>Type of gambling:</b> ${value?.textValue ? "(" + value?.textValue + ") " : ""}${typeGamblingArray.join(', ')}</div>`);
					}

					return `<h3><b>${substanceInfo?.substances || substance}</b>${displayAge}</h3>${children?.length ? `<ul>${children?.join("")}</ul>` : ""}`;
				}

				// Special case: Social Gambling
				if (substance === "social_gambling") {
					const contextValues = value?.usageContext ?? [];

					if (contextValues?.length > 0) {
						return `<h3><b>Social Gambling:</b> ${contextValues?.map((item) => `${item}`).join(", ")}</h3>`;
					} else {
						return `<h3><b>Social Gambling</b></h3>`;
					}
				}

				if (substance === "no_gambling") {
					return `<p>The client denies any gambling history.</p>`;
				}

				// Special case: Social Use and Religious Use
				if (["social_use", "religious_use"].includes(substance)) {
					const contextValues = value?.usageContext ?? [];
					const label = substanceInfo?.substances || substance;

					if (contextValues?.length > 0) {
						const labels = contextValues?.map(ctx => {
							const match = selectOptions?.find(opt => opt?.value === ctx);
							return match?.label || ctx;
						}).join(", ");

						return `<h3><b>${label}:</b> ${labels}</h3>`;
					} else {
						return `<h3><b>${label}</b></h3>`;
					}
				}

				// Special case: Not Applicable
				if (substance === "not_applicable") {
					return `<p>The client reports no substance use history.</p>`;
				}

				// Special case: Nicotine/Vapes
				let nicotineChildren = [];
				const renderedKeys = new Set(["age"]);

				if (substance === "nicotine_vapes" && Array.isArray(substanceInfo?.nicotineOptions)) {
					substanceInfo?.nicotineOptions.forEach(opt => {
						renderedKeys?.add(opt.value);
						const optData = value[opt?.value];
						if (optData?.checked) {
							const optAge = optData?.age || "_____";
							nicotineChildren?.push(`<li>${opt.label} at age ${optAge}</li>`);
						}
					});
				}

				// Track rendered keys for gambling too
				if (substance === "gambling" && Array.isArray(substanceInfo?.gamblingOptions)) {
					substanceInfo?.gamblingOptions.forEach(opt => renderedKeys?.add(opt.value));
				}

				// Generic substances
				output += `<h3><b>${substanceInfo?.substances || substance}</b>${displayAge}</h3>`;
				if (nicotineChildren.length > 0) {
					output += `<ul>${nicotineChildren?.join("")}</ul>`;
				}

				// Fallback: render any remaining unrendered child keys
				const otherChildren = Object.entries(value)
					.filter(([key, val]) =>
						typeof val === "object" &&
						val?.checked &&
						!renderedKeys.has(key)
					)
					.map(([childKey, childVal]) => {
						const childAge = childVal?.age || "_____";
						const label = childKey?.charAt(0).toUpperCase() + childKey?.slice(1)?.replace(/_/g, " ");
						return `<li>${label} at age ${childAge}</li>`;
					});

				if (otherChildren?.length) {
					output += `<ul>${otherChildren?.join("")}</ul>`;
				}

				return output;
			}).join("");
		})();

		const checkedSubstances = s_substance && typeof s_substance === "object"
			? Object.entries(s_substance).filter(([, value]) => value.checked)
			: [];

		const checkedKeys = checkedSubstances.map(([key]) => key);

		// Flags
		const hasNotApplicable = checkedKeys.includes("not_applicable");
		const hasNoGambling = checkedKeys.includes("no_gambling");


		const generateDrugsPayload = () => {
			if (hasNotApplicable) {
				return `The client reports no substance use history. However, ${lowPronoun} reported problems in the past 12 months with`;
			}

			const drugSubstances = constants.Substances.filter(
				sub => !GAMBLING_KEYS.includes(sub.key) &&
					sub.key !== "not_applicable" &&
					checkedKeys.includes(sub.key)
			);

			const rendered = drugSubstances.map(substanceInfo => {
				const substance = substanceInfo.key;
				const value = s_substance[substance];
				const displayAge = !EXCLUDED_AGE_KEYS.includes(substance)
					? ` at age ${value.age || "_____"}`
					: "";

				// Special case: Social Use and Religious Use
				if (["social_use", "religious_use"].includes(substance)) {
					const contextValues = value?.usageContext ?? [];
					const label = substanceInfo?.substances || substance;

					if (contextValues.length > 0) {
						const labels = contextValues.map(ctx => {
							const match = selectOptions.find(opt => opt.value === ctx);
							return match?.label || ctx;
						}).join(", ");

						return `<h3><b>${label}:</b> ${labels}</h3>`;
					} else {
						return `<h3><b>${label}</b></h3>`;
					}
				}

				if (substance === "other") {
					return `<h3><b>Other:</b> ${value.textValue || "_____"}</h3>`;
				}

				let output = `<h3><b>${substanceInfo.substances}</b>${displayAge}</h3>`;

				// Nicotine handling
				if (substance === "nicotine_vapes" && Array.isArray(substanceInfo.nicotineOptions)) {
					const children = substanceInfo.nicotineOptions.map(opt => {
						const optData = value[opt.value];
						if (optData?.checked) {
							const optAge = optData.age || "_____";
							return `<li>${opt.label} at age ${optAge}</li>`;
						}
						return null;
					}).filter(Boolean);

					if (children.length) {
						output += `<ul>${children.join("")}</ul>`;
					}
				}

				return output;
			});

			return rendered.length ? (`Client was seen ${formValues?.problem_1}, and during ${lowPossPronoun} assessment, outlined ${lowPossPronoun} substance abuse history. ${formValues?.first_name} reported that ${lowPronoun} had begun to use ${rendered.join("")} gradually increasing amounts to achieve the desired effect over a longer period of time than intended, despite problems in the past 12 months with`) : "";
		};

		const generateGamblingPayload = () => {
			if (hasNoGambling) {
				return `<h3>The client denies any gambling history.</h3>`;
			}

			const gamblingSubstances = constants.Substances.filter(
				sub => GAMBLING_KEYS.includes(sub.key) &&
					sub.key !== "no_gambling" &&
					checkedKeys.includes(sub.key)
			);

			const rendered = gamblingSubstances.map(substanceInfo => {
				const substance = substanceInfo.key;
				const value = s_substance[substance];
				const displayAge = !EXCLUDED_AGE_KEYS.includes(substance)
					? ` at age ${value.age || "_____"}`
					: "";

				// Special case: Social Gambling
				if (substance === "social_gambling") {
					const contextValues = value?.usageContext ?? [];

					if (contextValues.length > 0) {
						return `<h3><b>Social Gambling:</b> ${contextValues.map((item) => `${item}`).join(", ")}</h3>`;
					} else {
						return `<h3><b>Social Gambling</b></h3>`;
					}
				}

				let output = `<h3><b>${substanceInfo.substances}</b>${displayAge}</h3>`;

				if (substance === "gambling" && Array.isArray(substanceInfo.gamblingOptions)) {
					const children = Object.entries(value)
						.filter(([key, val]) => typeof val === "object" && val.checked)
						.map(([childKey, childVal]) => {
							const match = substanceInfo.gamblingOptions.find(opt => opt.value === childKey);
							if (match) {
								const sentence = childVal.checked ? match.yes : match.no;
								return `<li><h3>The client ${sentence}</h3></li>`;
							}
							return null;
						}).filter(Boolean);

					if (formValues?.type_gambling || value?.textValue) {
						const typeGamblingArray = Array.isArray(formValues?.type_gambling)
							? formValues.type_gambling
							: (formValues?.type_gambling ? [formValues.type_gambling] : []);

						children.push(`<div><b>Type of gambling:</b> ${value.textValue ? "(" + value.textValue + ") " : ""}${typeGamblingArray.join(', ')}</div>`);
					}

					if (children.length) {
						output += `<ul>${children.join("")}</ul>`;
					}
				}

				return output;
			});

			return rendered.length ? rendered.join("") : "";
		};

		const drugsOutput = generateDrugsPayload();
		const gamblingOutput = generateGamblingPayload();

		// const drugPart1Payload = `<h3>${n_type !== "3" ? "gradually increasing amounts to achieve the desired effect over a longer period of time than intended, despite problems in the past 12 months with" : "However, " + lowPronoun + " reported problems in the past 12 months with"}</h3>`;
		const reasonsPayload = constants.Reasons
			.filter((reason) => s_reasons && s_reasons[reason.key]?.checked)
			.map((reason) => {
				if (Array.isArray(constants.ReasonValues[reason.key])) {
					const checkedCauses = constants.ReasonValues[reason.key]
						.filter((cause) => s_reasons[reason.key]?.causes?.[cause]);
					return `<h3><b>${reason.reason}</b>: ${checkedCauses.length ? checkedCauses.join(", ") : "______"}</h3>`;
				} else {
					const cause = s_reasons[reason.key]?.cause || "______";
					return `<h3><b>${reason.reason}</b>: ${cause}</h3>`;
				}
			})
			.join("");


		const isNotApplicable = s_attempts?.B?.checked;

		const attemptsPayload = (constants.CageScreeningPre || [])
			.filter(item => s_attempts?.[item.key]?.checked && item.key !== "B")
			.map(item => item.answer)
			.filter(Boolean)
			.join(", ");

		const generateDrugPart4Payload = () => {
			let output = '';

			if (!hasNotApplicable) {
				output += 'caused or exacerbated by use of substances, including reduced involvement in social activities.';
			}

			if (isNotApplicable) {
				output += '<br>CAGE screening is not applicable.';
			} else if (attemptsPayload) {
				output += `<br>The client reported several attempts to ${attemptsPayload}.`;
			}

			return output;
		};

		const drugPart4Payload = generateDrugPart4Payload();

		let orientationchange = constants.orientationOptions?.findIndex((val) => val?.value === formValues?.orientation_to_change);
		const selectedOptionIndex = constants.SourceOption?.findIndex(
			val => val?.value === formValues?.source
		);
		const selectedLabel = constants?.SourceOption[selectedOptionIndex]?.label || "____";
		let sourceDetailsText = "";
		if (formValues?.source === "8" || formValues?.source === "9") {
			sourceDetailsText = formValues?.source_details ? ` (${formValues.source_details})` : "";
		}
		const reasonforcallabel = constants.ReasonForCallOptions?.find(option => option.value === formValues?.reason)?.label || "";
		const additionalReason = formValues?.reason === "9" && formValues?.other_reasonforcall
			? ` (${formValues.other_reasonforcall})`
			: "";
		const sexualOrientationLabel = constants.SexualOrientationOption?.find(option => option.value === formValues?.sexula_orientation)?.label || "";
		const relationtoRecipientlabel = constants.RelationtoRecipientOptions?.find(option => option.value === formValues?.relation_to_recipient)?.label || "";
		// const drugsEndPayload = `<p><br></p><h3>${formValues.first_name} ${formValues.drug_1} gambling activity${formValues.drug_1 === 'denies any' ? "" : " and " + formValues.drug_2}. ${formValues.drug_3} family of origin ${formValues.drug_11} problems. Client reports ${lowPronoun} has ${formValues.drug_4} previously treated for addiction${formValues.drug_4 !== "never been" ? ((formValues.drug_5 !== "_________" ? " at " + formValues.drug_5 : "") + (formValues.drug_5 !== "_________" && formValues.drug_6 !== "_________" ? " and" : "") + (formValues.drug_6 !== "_________" ? " with " + formValues.drug_6 : "")) : ""}; has ${formValues.drug_7} recovering friends; ${formValues.drug_8} prior 12-step program experience and longest period of abstinence is ${formValues.drug_9}.</h3>`;
		const planPayload = assessmentType === 1 ? `<b><u>PLAN:</u></b><br><h3>The client will be sent a self-assessment form to complete and submit before the next appointment can be scheduled, which will be delivered to the provided email address (<em>${formValues?.email || ''}</em>) to assist with further assessment and referral.</h3>` : `<h3>Client was informed that ${lowPronoun} ${beVerb} required to ${formValues?.plan_2} prior to the commencement of coaching. ${formValues?.first_name} said ${lowPronoun} would ${formValues?.plan_1}, and then call back.</h3>`;
		let affectedBy;
		if (formValues?.assess_5 && formValues.assess_5 !== "not applicable") {
			affectedBy = `Client appears to be affected by ${formValues.assess_5} and`;
		} else if (reasonforcallabel || additionalReason) {
			affectedBy = `Client appears to be affected by ${reasonforcallabel}${additionalReason} and`;
		} else {
			affectedBy = formValues?.first_name;
		}
		const assessmentPrePayload = `${affectedBy} was informed about our recovery program, which includes psychiatric, psychological, and therapeutic sessions, along with structured group work (if required).`;

		const disordersText = Object.entries(diagnosisData)
			.filter(([_, values]) => Array.isArray(values) && values.length > 0)
			.map(([key, values]) => {
				const label = Object.keys(diagnosisTypeMap).find(k => diagnosisTypeMap[k].name === key);
				const options = diagnosisTypeMap[label]?.options || [];
				const labels = values.map(val => options.find(o => o.value === val)?.label || val);
				return `${label}: ${labels.join(', ')}`;
			})
			.join('; ');

		const assessmentPayload = assessmentType === 1 ? `<h3>${assessmentPrePayload}</h3>` : `<h3>${formValues?.first_name} presented as well-groomed and reported performing daily functions regularly. ${pronoun} ${beVerb} ${formValues?.assess_1} about coaching and present as ${constants?.MaritalStatusOption[orientationchange]?.label || "____"} in ${lowPossPronoun} approach to change. Based on the ${formValues?.assess_2} assessment screening instruments, ${lowPronoun} ${formValues?.assess_3} to meet ICD criteria for ${disordersText} disorder and is ${formValues?.assess_4} for coaching/counseling.</h3>`;
		// const addictionPayload = `<h3><em><u>Addiction/Recovery History:</u></em></h3><h3>${pronoun} ${formValues.addiction_1} personal history of substance abuse${formValues.addiction_3 ? (" (other than occasional " + formValues.addiction_3 + " use of alcohol)") : ""}. ${formValues.addiction_2} gambling activity. ${n_type !== "3" ? `${pronoun} stated that, to the best ${lowPossPronoun} recollection, ${lowPossPronoun} family member ${formValues.problem_2} had begun to use` : ""}</h3>${n_type !== "3" ? drugsPayload : ""}${drugPart1Payload}${reasonsPayload}${n_type !== "3" ? `<h3>${drugPart4Payload + attemptsPayload + (attemptsPayload ? "." : "")}</h3>${drugsEndPayload}` : ""}`;
		// ${n_type !== "1" ? (addictionPayload + "<p><br></p>") : ""}   //add for dataPayload
		const introPayload = `<h3>${formValues?.first_name} is a ${formValues?.age}-year-old ${formValues?.intro_1}, ${sexualOrientationLabel || ""}, ${formValues?.intro_2}, ${formValues?.intro_3}, ${formValues?.gender === "Other" ? formValues?.gender_details : formValues?.gender} from ${formValues?.location}, living in ${value?.family_17}, who was referred for an assessment by ${selectedLabel}${sourceDetailsText}.
        ${formValues?.reason ? `${constants.ReasonForCall}: ${reasonforcallabel || ''} ${additionalReason}` : ""}
				Reason (in detail): ${formValues?.presenting_problem_text || ""} ${formValues?.presenting_problem_detail || ""}
        ${formValues?.service === "1" ? `${formValues?.first_name} ${constants.ServiceTextYes}` : `${formValues?.first_name} ${constants.ServiceTextNo}`}
        ${constants.EmergencyContactName}: ${formValues?.emergency_contact_name || ''} 
				Emergency Contact No.: ${value?.emergency_contact_number || ''} 
        ${constants.RelationtoRecipient}: ${relationtoRecipientlabel}
        </h3>`;

		// Function to generate mental health sentences for payload
		const generateMentalHealthSentences = (formValues) => {
			const sentences = [];
			sentences.push(getSelfAssessmentSentencefromPreAssess("mental_treat", value?.mental_treat));

			// Mental health diagnoses
			if (formValues?.emotional_2 && formValues?.emotional_2.length > 0) {
				const emotionalDiagnoses = Array.isArray(formValues?.emotional_2) ? formValues?.emotional_2 : [];
				// If "None" is selected along with others, ignore it
				const hasNone = emotionalDiagnoses.includes("None");

				const diagnoses = emotionalDiagnoses.filter(
					(item) => item !== "Other" && item !== "None"
				);

				if (hasNone && diagnoses.length === 0) {
					sentences.push("The client reports no known mental or emotional health diagnoses.");
				} else if (diagnoses.length > 0) {
					let diagnosisText;
					if (diagnoses.length === 1) {
						diagnosisText = diagnoses[0];
					} else if (diagnoses.length === 2) {
						diagnosisText = diagnoses.join(" and ");
					} else {
						diagnosisText = diagnoses.slice(0, -1).join(", ") + ", and " + diagnoses.slice(-1)[0];
					}
					sentences.push(`The client has been diagnosed with ${diagnosisText}.`);
				}

				// Add other mental health conditions if specified
				if (formValues?.emotional_2.includes('Other') && formValues?.otherhealth) {
					sentences.push(`The client has also been diagnosed with ${formValues?.otherhealth}.`);
				}
				// If user doesn't select "SI" or "HI", show a denial sentence
				const hasSI = emotionalDiagnoses.includes("SI (Suicidal Ideation)");
				const hasHI = emotionalDiagnoses.includes("HI (Homicidal Ideation)");

				if (!hasSI && !hasHI) {
					sentences.push("The client denies any history of suicidal or homicidal ideation.");
				} else {
					if (!hasSI && hasHI) {
						sentences.push("The client denies any history of suicidal ideation.");
					}
					if (hasSI && !hasHI) {
						sentences.push("The client denies any history of homicidal ideation.");
					}
				}
			}

			// Treatment history
			if (formValues?.emotional_10) {
				const treatmentStatus = formValues?.emotional_10 === 'received' ? 'has' : 'has never';
				sentences.push(`The client ${treatmentStatus} received treatment for mental/emotional health conditions.`);

				// Add therapist details if treatment was received
				if (formValues?.emotional_10 === 'received' && formValues?.emotional_3) {
					sentences.push(`The treating therapist/doctor was ${formValues?.emotional_3}.`);
				}
			}

			// Hospitalization history
			if (formValues?.emotional_11) {
				const hospitalizationStatus = formValues?.emotional_11 === 'was' ? 'has been' : 'has not been';
				sentences.push(`The client ${hospitalizationStatus} hospitalized for mental/emotional health conditions.`);

				// Add hospital details if hospitalized (Note: form field name is empty, might need to fix)
				if (formValues?.emotional_11 === 'was' && formValues?.hospital_details) {
					sentences.push(`Hospital details: ${formValues?.hospital_details}.`);
				}
			}

			// Medication status
			if (formValues?.emotional_12) {
				const medicationStatus = formValues?.emotional_12 === 'medication' ? 'is currently on' : 'is not on';
				sentences.push(`The client ${medicationStatus} medication for mental/emotional health conditions.`);

				// Add medication details if on medication
				if (formValues?.emotional_12 === 'medication' && formValues?.emotional_5) {
					sentences.push(`Current medications include: ${formValues?.emotional_5}.`);
				}
			}

			// Family history
			if (formValues?.family_mental_health) {
				switch (formValues?.family_mental_health) {
					case 'none':
						sentences.push("The client reports no known family history of mental health or emotional health concerns.");
						break;
					case 'present':
						sentences.push("The client reports a family history of mental health or emotional health concerns.");
						if (formValues?.family_mental_health_details) {
							sentences.push(`Family history details: ${formValues?.family_mental_health_details}.`);
						}
						break;
					case 'unsure':
						sentences.push("The client is unsure about family history of mental health concerns or prefers not to say.");
						break;
				}
			}

			return sentences;
		};

		const emotionalPayload = `<h3><em><u>Mental/Emotional Health:</u></em></h3><h3>${generateMentalHealthSentences(formValues).join(' ')}</h3>`;

		const generateMedicalSummary = (values) => {
			const sentences = [];

			// Health Status
			if (values.medical_2) {
				sentences.push(`The client's health status is reported as ${values.medical_2}.`);
			}

			// Last Checkup
			if (values.last_checkup_status === '1' && values.medical_3?.date && values.medical_3?.month && values.medical_3?.year) {
				const { date, month, year } = values.medical_3;
				const formattedDate = `${month.padStart(2, '0')}/${date.toString().padStart(2, '0')}/${year}`;
				sentences.push(`The last checkup was on ${formattedDate}.`);
			} else if (values.last_checkup_status === '2') {
				sentences.push("The client does not remember their last checkup date.");
			}

			// Allergies
			if (values.medical_4 === "Allergies") {
				sentences.push(`The client has allergies: ${values.medical_5 || "Details not provided"}.`);
			} else if (values.medical_4 === "no Allergies") {
				sentences.push("The client reports having no allergies.");
			}

			// Medications/OTCs
			if (values.medical_8 === "medications/OTCs") {
				sentences.push(`The client is taking medications or OTCs: ${values.medical_9 || "Details not provided"}.`);
			} else if (values.medical_8 === "no medications/OTCs") {
				sentences.push("The client is not taking any medications or OTCs.");
			}

			// Dietary Habits
			const diet = constants.DietaryHabbits.find(d => d.key === values.medical_10);
			if (diet) {
				sentences.push(`The client follows a ${diet.label.toLowerCase()} diet.`);
			}

			// Illnesses/Diseases
			if (values.medical_6 === "illnesses/disease") {
				const illnesses = values.selected_illnesses || [];

				// Replace "Other" with the value from "other_illness"
				const illnessList = illnesses.map((illness) =>
					illness === "Other" ? values.other_illness : illness
				);

				const illnessSentence = `The client has the following illnesses or diseases: ${illnessList.join(', ')}.`;
				sentences.push(illnessSentence);
			} else if (values.medical_6 === "no illnesses/disease") {
				sentences.push("The client reports having no illnesses or diseases.");
			}

			// Symptoms
			// if (values?.mentalhealthoption?.length > 0) {
			// 	const symptomsList = values.mentalhealthoption.map(symptom => {
			// 		if (symptom === "other_major_physical") {
			// 			return values.other_major_health_detail;
			// 		}

			// 		const option = constants.MentalHealthOptions.find(opt => opt.value === symptom);
			// 		return option ? option.label : symptom;
			// 	});

			// 	const symptomSentence = `The client has experienced the following: ${symptomsList.join(', ')}.`;
			// 	sentences.push(symptomSentence);
			// } else {
			// 	sentences.push("The client has not experienced any symptoms.");
			// }

			return sentences.join(' ');
		};

		const medicalPayload = `<h3><em><u>Medical Health:</u></em></h3><h3>${generateMedicalSummary(formValues)}<h3>`;
		let maritalstatuslabelindex = constants.MaritalStatusOption?.findIndex((val) => val?.value === value?.maritalstatus);
		let educationlabelindex = constants.EducationOptions?.findIndex((val) => val?.value === formValues?.family_10);
		let occupationlabelindex = constants.OccupationOptions?.findIndex((val) => val?.value === formValues?.family_11);
		const socialPayload = `<h3>${pronoun} ${beVerb} ${formValues?.family_13} and the client ${formValues?.family_14} exercise, hobbies, recreational interests, sports, leisure activities ${(formValues?.family_14 === "does no") ? "" : "like " + formValues?.family_15} in ${lowPossPronoun} free time.</h3>`;
		const supportiveFamilySentence = (formValues?.family_3 && formValues?.family_3 !== 'living alone' && value?.supportive_family)
			? `Client ${value?.supportive_family === 'yes' ? 'reports stable supportive relationship with family/friends. ' : 'reports non-supportive relationship with family/friends. '}`
			: "";
		const family_Para = `<h3>Client is the ${formValues?.family_1 === 'only' ? (formValues?.family_1 + ' child') : ((formValues?.family_1 || "") + " of " + (value?.family_2 || "") + " children")} and is ${formValues?.family_3 || ""}. ${supportiveFamilySentence + pronoun} report${past} that ${lowPronoun} ${beVerb} ${value?.maritalstatus ? constants?.MaritalStatusOption[maritalstatuslabelindex]?.label : '----'}. ${pronoun} report${past} ${formValues?.family_4} relations with family of origin (parents) (Father: ${value?.father_name || ""}, Mother: ${value?.mother_name || ""})${formValues?.family_5 ? ` and ${formValues?.family_5} relations with nuclear family (Spouse/partner)${formValues?.spouse_name ? ` (${formValues?.spouse_name})` : ''}` : ''}, ${formValues?.family_6 === "has no" ? "" : ("and has children (" + formValues?.children_name + " " + formValues?.family_7 + ")")}. ${formValues?.family_1 === "only" ? "" : `Client reports ${value?.family_16 || ""} sibling relations (${value?.sibling_display}).`}</h3>`;
		const spiritual_Para = `<h3>The client identifies their religion as ${formValues?.intro_3}. ${getSelfAssessmentSentencefromPreAssess("spiritual_3", value?.spiritual_3)} ${value?.spiritual_1 ? `Regarding their spiritual and religious beliefs, the client states: "${value?.spiritual_1}". ` : ""}The client believes their spiritual beliefs and values will support their recovery in the following way: "${value?.spiritual_2}"</h3>`;
		const educational_Para = `<h3>${formValues?.first_name} has completed ${constants?.EducationOptions[educationlabelindex]?.label || "-------"}${(formValues?.family_10 === "14" || formValues?.family_10 === "15") ? ` - ${formValues?.education_details || ""}` : ""} and ${constants?.OccupationOptions[occupationlabelindex]?.label || "-------"}${(formValues?.family_11 === "works as a") ? formValues?.family_12 : ""}.</h3>`;
		const legal_Para = `<h3>${formValues?.first_name} reports ${formValues?.family_8} legal issues${(formValues?.family_8 === "current") ? (" (" + formValues?.family_9 + ")") : ""}.</h3>`;
		const familyPayload = `<h3><em><u>Social leisure:</u></em></h3>${socialPayload}<br><h3><em><u>Family:</u></em></h3>${family_Para}<br><h3><em><u>Spirituality/Religion:</u></em></h3>${spiritual_Para}<br><h3><em><u>Education:</u></em></h3>${educational_Para}<br><h3><em><u>Legal:</u></em></h3>${legal_Para}`;
		const hasNoneSelected = Array.isArray(formValues?.exercise) && formValues.exercise.includes("None");

		const socialPrePayload = `<h3><em><u>Social leisure:</u></em></h3><h3>${hasNoneSelected
			? "Client reports lack of healthy social or leisure activity."
			: `Client reports healthy social and leisure activity${formValues?.family_15 ? ` (${formValues.family_15}).` : "."}`
			}</h3>`;

		const onlyEmotionalOrFamily =
			value?.presenting_problem_options?.some((val) => ["4", "5", "6"].includes(val)) &&
			!value?.presenting_problem_options?.some((val) => ["1", "2", "3"].includes(val));

		const generateAddictionSentences = (formValues) => {
			const sentences = [];

			// Treatment history
			if (formValues?.drug_4) {
				const treatmentStatus = formValues?.drug_4 === 'been' ? 'has' : 'has never';
				sentences.push(`The client ${treatmentStatus} received treatment for addiction.`);

				// Add institute and therapist info if treatment was received
				if (formValues?.drug_4 === 'been') {
					if (formValues?.drug_5) {
						sentences.push(`Treatment was received at ${formValues?.drug_5}.`);
					}
					if (formValues?.drug_6) {
						sentences.push(`The treating therapist/doctor was ${formValues?.drug_6}.`);
					}
				}
			}

			// 12-step program experience
			if (formValues?.drug_8) {
				if (formValues?.drug_8 === 'no') {
					sentences.push("The client has no experience with 12-step programs.");
				} else if (formValues?.drug_8 === 'yes') {
					sentences.push("The client has experience with 12-step programs.");

					// Handle meetings/services (array from Select in 'tags' mode)
					if (Array.isArray(formValues?.drug_12) && formValues?.drug_12.length > 0) {
						const meetingList = formValues?.drug_12.join(', ');
						sentences.push(`The client has participated in the following meetings/services: ${meetingList}.`);
					}
				} else {
					// Catch unrecognized or new options (e.g., 'some')
					sentences.push(`The client has ${formValues?.drug_8} experience with 12-step programs.`);
				}
			}

			// Friends in recovery
			if (formValues?.drug_7) {
				const friends = formValues?.drug_7 === 'no' ? 'no' : 'some';
				sentences.push(`The client has ${friends} friends in recovery from substances or gambling.`);
			}

			// Longest abstinence period
			if (formValues?.drug_9) {
				sentences.push(`The client's longest period of abstinence from substances/gambling was ${formValues?.drug_9}.`);
			}

			sentences.push(getSelfAssessmentSentencefromPreAssess("community_support", value?.community_support))

			return sentences;
		};

		const communityPayload = `<h3><em><u>Community:</u></em></h3><h3>${generateAddictionSentences(formValues).join(' ')}</h3>`;

		const generateGamblingSentences = (formValues) => {
			const sentences = [];
			if (formValues?.family_substance) {
				switch (formValues?.family_substance) {
					case 'none':
						sentences.push("The client reports no known family history of substance use or gambling use.");
						break;
					case 'present':
						sentences.push("The client reports a family history of substance use or gambling uses.");
						if (formValues?.family_substance_details) {
							sentences.push(`Family history details: ${formValues?.family_substance_details}.`);
						}
						break;
					case 'unsure':
						sentences.push("The client is unsure about family history of substance/gambling use or prefers not to say.");
						break;
				}
			}

			sentences.push(getSelfAssessmentSentencefromPreAssess("gambling_treat", value?.gambling_treat))

			return sentences;
		};

		// Pre-assessment Sentence:
		const treatmentValue = formValues?.substance_treat;
		let treatmentSentence = "";
		if (treatmentValue === "yes") {
			treatmentSentence = `${formValues?.first_name} reports a history of substance abuse treatment or attending AA/NA.`;
		} else if (treatmentValue === "no") {
			treatmentSentence = `${formValues?.first_name} denies any history of substance abuse treatment or attending AA/NA.`;
		};

		const questionsPreAssessmentSentences = constants.QuestionsPreAssessment
			.map((question) => {
				const answerValue = value?.[question.name];
				if (!answerValue || !question.responses) return "";

				const response = question.responses[answerValue];
				if (!response) return "";

				return `<h3><u><em>${question.title}</em></u></h3><h3>${response}</h3>`;
			})
			.filter(sentence => sentence !== "")
			.join('<br />');

		// Generate sentences for additional sections (Family, Education, Employment, Legal)
		const additionalSectionsSentences = constants.AdditionalPreAssessmentSections
			.map((section) => {
				let sectionSentences = [];

				section.fields.forEach((field) => {
					const answerValue = value?.[field.name];

					if (field.condition && !field.condition(value)) {
						return;
					}

					let sentence = "";

					if (field.responses && answerValue) {
						const response = field.responses[answerValue];
						if (response) {
							sentence = `${value?.first_name} ${response}`;
						}
					}
					else if (field.format) {
						sentence = field.format(answerValue, value?.first_name, value);
					}

					if (sentence) {
						sectionSentences.push(sentence);
					}
				});

				if (sectionSentences.length > 0) {
					return `<h3><u><em>${section.title}</em></u></h3><h3>${sectionSentences.join(" ")}</h3>`;
				}
				return "";
			})
			.filter(section => section !== "")
			.join("<br />");

		let PreNotesHTML = "<br />" + questionsPreAssessmentSentences + "<br />" + additionalSectionsSentences + "<br/>" + socialPrePayload;

		const problemPrePayload = `<b>${formValues?.first_name}${formValues?.last_name ? (" " + formValues?.last_name) : ""}</b>, ${formValues?.age} years old, was seen ${formValues?.problem_1} for an assessment.</br>Reason for contact: <b>${formValues?.presenting_problem_text || ""}</b></br>Reason (in detail): ${formValues?.presenting_problem_detail || ""}<br>`;
		const drugsPrePayload = `<br><em><u>Substance Use/Gambling History:</em></u> <br>${!hasNotApplicable ? `Client outlined their substance abuse history. ${formValues?.first_name} reported that they had begun to use<br>${drugsPayload}` : `${drugsPayload}`}`;
		const CAGEPrePayload = isNotApplicable ? `<br>CAGE screening is not applicable.<br>` : `<br>The client reported several attempts to <b>${attemptsPayload}.</b><br>`;
		const dataPrePayload = problemPrePayload + (value?.hasSubstanceUseHistory ? drugsPrePayload : "") + (treatmentSentence) + (onlyEmotionalOrFamily ? "" : CAGEPrePayload) + PreNotesHTML;
		const problemPayload = `<h3><u><em>Chemical/Substance</em></u></h3><h3>${drugsOutput + (reasonsPayload ?? "") + (drugPart4Payload ?? "") + " " + (treatmentSentence)}</h3>`;
		const gamblingPayload = `<h3><u><em>Gambling</em></u></h3><h3>${gamblingOutput}${generateGamblingSentences(formValues).join(' ')}</h3>`;

		const dataPayload = assessmentType === 1 ? `<h3>${dataPrePayload}</h3>` : `${introPayload}<p><br></p>${problemPayload}<p><br></p>${gamblingPayload}<p><br></p>${communityPayload}<p><br></p>${emotionalPayload}<p><br></p>${medicalPayload}<p><br></p>${familyPayload}`;
		let preAssessmentHeader = assessmentType === 1 ? "<p style='text-align:center; text-transform: uppercase;'><i><u><b>Pre-Assessment Intake</b></u></i></p>" : assessmentType === 2 ? "<p style='text-align:center; text-transform: uppercase;'><i><u><b>Self-Assessment Summary</b></u></i></p>" : "";
		// userAnswerValue.mentalhealthoption = selectedMentalHealthOption;
		const filteredDiagnosisData = Object.entries(diagnosisData).reduce((acc, [key, val]) => {
			if (Array.isArray(val) && val.length > 0) {
				acc[key] = val;
			}
			return acc;
		}, {});
		if (assessmentType === 2) {
			userAnswerValue.chemical_problem_para = `<h3>${drugsOutput + (reasonsPayload ?? "") + (drugPart4Payload ?? "") + " " + (treatmentSentence)}</h3>`;
			userAnswerValue.gambling_problem_para = `<h3>${gamblingOutput}${generateGamblingSentences(formValues).join(' ')}</h3>`;
			userAnswerValue.community_problem_para = `<h3>${generateAddictionSentences(formValues).join(' ')}</h3>`;
			userAnswerValue.mental_problem_para = `<h3>${generateMentalHealthSentences(formValues).join(' ')}</h3>`;
			userAnswerValue.medical_problem_para = `<h3>${generateMedicalSummary(formValues)}<h3>`;
			userAnswerValue.social_problem_para = `${socialPayload}`;
			userAnswerValue.family_problem_para = `${family_Para}`;
			userAnswerValue.spirituality_problem_para = `${spiritual_Para}`;
			userAnswerValue.education_problem_para = `<h3>${formValues?.first_name} has completed ${constants?.EducationOptions[educationlabelindex]?.label || "-------"}${(formValues?.family_10 === "14" || formValues?.family_10 === "15") ? ` - ${formValues?.education_details || ""}` : ""}.</h3>`;
			userAnswerValue.employment_problem_para = `Client is ${constants?.OccupationOptions[occupationlabelindex]?.label || "-------"}${(formValues?.family_11 === "works as a") ? formValues?.family_12 : ""}.`;
			userAnswerValue.legal_problem_para = `${legal_Para}`;
			userAnswerValue.new_assesment_disorder = filteredDiagnosisData;
		}
		let admin_id = getCookie(COOKIE.ClientId);
		let payload = {
			notes_content: noteValue[0] ? (n_type === "8" ? `<p style='text-align:center; text-transform: uppercase;'><i><u><b>Group Note</b></u></i></p>` : "") + "<b><u>DATA:</u></b> " + noteValue[0] : (n_type !== "0" && n_type !== "8") ? preAssessmentHeader + "<b><u>DATA:</u></b> " + dataPayload : "",
			notes_assesment: noteValue[1] ? "<b><u>ASSESSMENT:</u></b>" + " " + noteValue[1] : (n_type !== "0" && n_type !== "8") ? "<b><u>ASSESSMENT:</u></b>" + " " + assessmentPayload : "",
			notes_plan: assessmentType === 1 ? planPayload : (noteValue[2] ? "<b><u>PLAN:</u></b>" + " " + noteValue[2] : (n_type !== "0" && n_type !== "8") ? "<b><u>PLAN:</u></b>" + " " + planPayload : ""),
			section_id: assessmentType === null ? null : "0",
			notes_type: assessmentType === 1 ? "5" : assessmentType === 2 ? "4" : n_type,
			dt_created: `${noteDate.year}-${noteDate.month}-${noteDate?.date}`,
			answers: userAnswerValue
		};
		if (assessmentType === null) {
			if (adminClientValuefromSession?.clientId || adminClientValuefromSession?.clientId) {
				payload.client_id = adminClientValuefromSession?.clientId || adminClientValuefromSession?.clientId;
			} else {
				payload.enquiry_id = adminClientValuefromSession?.enquiryId;
			}
		} else {
			if (adminClientValuefromSession?.client_id || adminClientValuefromSession?.clientId) {
				payload.client_id = adminClientValuefromSession?.client_id || adminClientValuefromSession?.clientId;
				payload.enquiry_id = adminClientValuefromSession?.enquiry_info?.enquiry_id;
			} else {
				payload.enquiry_id = adminEnquiryValuefromSession?.enquiry_id;
			}
		}
		if (assessmentType === 2 && type === "add") {
			payload.admin_id = null
		} else {
			payload.admin_id = admin_id
		}
		if (sessionChecked === true) {
			payload.session_checked = sessionChecked;
		}
		if (noteTypeValue === "0" || noteTypeValue === "8") {
			const clientName = enquiryClientDetails?.client_firstname || "Client";
			const hasManualAssessment = !!noteValue[1];
			const hasBehaviors = assessmentBehavior?.length > 0;

			const behaviorSentence = hasBehaviors
				? `<h3>${clientName} ${assessmentBehavior?.join(', ')}.</h3>`
				: '';

			payload.notes_assesment_behaviour = behaviorSentence;

			if (!hasManualAssessment && hasBehaviors) {
				payload.notes_assesment = "<b><u>ASSESSMENT:</u></b>";
			}

			payload.answers = {
				...payload.answers,
				assessment_behavior: assessmentBehavior,
				...(noteTypeValue === "8" ? { group_name: props?.location?.state?.answers?.group_name || "", plan_option: planValue, ...(isPlanSelected && planValue === constants.PlanOption[0].label && {
					email_type: 1
				})} : {})
			};
		}

		if (type === "esign") {
			payload.signed_by = admin_id;
			const currentDate = new Date();
			payload.dt_updated = currentDate.toISOString().split("T")[0];
		}
		let url, method;
		if (props?.path === "/edit-note" || props?.path === "/edit-pre-assessment-intake" || props?.path === "/edit-self-assessment-summary") {
			url = "/edit-notes";
			method = "put";
			payload.notes_id = props && props.location && props.location.state && props.location.state.notes_id
		} else {
			url = "/add-notes";
			method = "post";
		}
		if (noteValue !== null) {
			fetchAdminApi(url, method, payload).then((res) => {
				if (res?.code && res.code === 200) {
					if (assessmentType === null) {
						setNoteDate({
							...noteDate,
							date: current.getDate(),
							month: String(current.getMonth() + 1).padStart(2, '0'),
							year: current.getFullYear()
						});
						message.success(res.message);
						hideModal();
						setLoader(false);
					} else {
						// if (assessmentType === 1 && method === "post" && adminEnquiryValuefromSession?.is_minor !== "1") sendRegistrationLink(formValues?.email);
						onSubmitComplete(true);
					}
				} else {
					if (assessmentType === null) {
						message.error(res.message);
						setLoader(false);
					} else {
						onSubmitComplete(false);
					}
				}
			});
		}
	};

	// const sendRegistrationLink = (email) => {
	// 	let payload = {
	// 		client_firstname: enquiryClientDetails?.client_firstname,
	// 		client_email: enquiryClientDetails?.client_email || email,
	// 		flag: "2",
	// 		email_type: "1",
	// 		token: enquiryClientDetails?.token
	// 	}
	// 	if (enquiryClientDetails?.is_minor === "1") {
	// 		payload.parent_firstname = enquiryClientDetails?.parent_firstname
	// 		payload.parent_lasttname = enquiryClientDetails?.parent_lastname
	// 	}
	// 	fetchApi(`/send-registration-link`, "post", payload)
	// 		.then((res) => {
	// 			if (res?.code === 200) {
	// 				console.log("link sent")
	// 			} else {
	// 				message.error(res?.message);
	// 			}
	// 		});
	// };

	// Individual Field onChange functions
	const handleDrug1Change = (value) => {
		setIsDrug1Selected(value === 'denies any');
	};
	const handleDrug4Change = (value) => {
		setIsDrug4Selected(value === 'never been');
	};
	const handleFamily1Change = (value) => {
		setIsFamily1Selected(value === 'only');
	};
	const handleFamily6Change = (value) => {
		setIsFamily6Selected(value === "has no");
	};
	const handleFamily8Change = (value) => {
		setIsFamily8Selected(value === 'current');
	};
	const handleFamily11Change = (value) => {
		setIsFamily11Selected(value === "works as a");
	};
	const handleFamily14Change = (value) => {
		setIsFamily14Selected(value === "does no");
	};
	const handleEmotional1Change = (value) => {
		setIsEmotional1Selected(value === "denies");
	};
	const handleEmotional9Change = (value) => {
		setIsEmotional9Selected(value === "denies");
	};
	const handleEmotional10Change = (value) => {
		setIsEmotional10Selected(value === "never received");
	};
	const handleEmotional11Change = (value) => {
		setIsEmotional11Selected(value === "was not");
	};
	const handleEmotional12Change = (value) => {
		setIsEmotional12Selected(value === "no medications");
	};
	const handleMedical4Change = (value) => {
		setIsMedical4Selected(value === "Allergies");
	};
	const handleMedical6Change = (value) => {
		setIsMedical6Selected(value === "illnesses/disease");
	};
	const handleMedical8Change = (value) => {
		setIsMedical8Selected(value === "medications/OTCs");
	};
	// Handle checkbox change for substance
	const handleCheckboxSubChange = (substance, isChecked, index = null) => {
		if (index !== null) {
			setSelectedSubstances((prev) => (
				{
					...prev,
					[substance]: { ...prev[substance], [index]: { checked: isChecked } },
				}));
		} else {
			setSelectedSubstances((prev) => (
				{
					...prev,
					[substance]: { ...prev[substance], checked: isChecked },
				}));
		}
	};
	// Handle checkbox change for reason
	const handleCheckboxReaChange = (reason, isChecked) => {
		setSelectedReasons((prev) => ({
			...prev,
			[reason]: { ...prev[reason], checked: isChecked, cause: isChecked ? prev[reason]?.cause || constants.ReasonValues[reason] : "", },
		}));
	};
	// Handle checkbox change for attempts
	const handleCheckboxAttemptChange = (attempt, isChecked) => {
		setSelectedAttempts((prev) => ({
			...prev,
			[attempt]: { ...prev[attempt], checked: isChecked },
		}));
	};
	// Handle input change for age
	const handleAgeChange = (substance, age, index = null) => {
		if (index !== null) {
			setSelectedSubstances((prev) => ({
				...prev,
				[substance]: {
					...prev[substance],
					[index]: {
						...prev[substance]?.[index],
						age,
					},
				},
			}));
		} else {
			setSelectedSubstances((prev) =>
			({
				...prev,
				[substance]: { ...prev[substance], age },
			}));
		}
	};
	const handleGamblingChange = (substance, value) => {
		setSelectedSubstances((prev) => (
			{
				...prev,
				[substance]: { ...prev[substance], textValue: value },
			}));
	};
	// Handle input change for cause
	const handleCauseChange = (reason, cause) => {
		setSelectedReasons((prev) => ({
			...prev,
			[reason]: { ...prev[reason], cause },
		}));
	};
	const handleNestedCauseChange = (reason, cause, checked) => {
		setSelectedReasons((prevSelectedReasons) => ({
			...prevSelectedReasons,
			[reason]: {
				...prevSelectedReasons[reason],
				causes: {
					...prevSelectedReasons[reason]?.causes,
					[cause]: checked
				}
			}
		}));
	};

	// Handle checkbox change for MENTAL HEALTH Option
	const handleCheckboxMentalHealthOption = (val) => {
		setSelectedMentalHealthOption(val);
	};

	const handleEducationChange = (val) => {
		setShowEducationDetails(val === "14" || val === "15" ? true : false);
	};

	// Individual forms
	const introForm = () => {
		const relationtoRecipientlabel = constants.RelationtoRecipientOptions?.find(option => option.value === props?.location?.state?.answers?.relation_to_recipient)?.label || '';
		const reasonforcallabel = constants.ReasonForCallOptions?.find(option => option.value === props?.location?.state?.answers?.reason)?.label || '';
		const sexualOrientationLabel = constants.SexualOrientationOption?.find(option => option.value === props?.location?.state?.answers?.sexula_orientation)?.label || '';
		return (
			<>
				<Space wrap align="center" className="">
					<Form.Item name={"first_name"}>
						<Input placeholder={constants.FirstName} />
					</Form.Item>
					{"is a"}
					<Form.Item name="age">
						<Input type="number" placeholder="Age" />
					</Form.Item>
					{"year old"}
					<Form.Item name="intro_1">
						{custom_select(true, "single/divorced/married", null, maritalStatus, addMaritalStatus, newMaritalStatus, (e) => setNewMaritalStatus(e.target.value), maritalStatusInputRef)}
					</Form.Item>
					{",\u00A0\u00A0"}
					<Form.Item name="intro_2">
						{custom_select(true, "Asian Indian/White/Black/Hispanic", null, ethnicity, addEthnicity, newEthnicity, (e) => setNewEthnicity(e.target.value), ethnicityInputRef)}
					</Form.Item>
					{",\u00A0\u00A0"}
					<Form.Item name="intro_3">
						{custom_select(true, constants.ReligionPlaceHolder, null, religion, addReligion, newReligion, (e) => setNewReligion(e.target.value), religionInputRef)}
					</Form.Item>
					{",\u00A0\u00A0"}
					<Form.Item name="gender">
						<Select placeholder="Male/Female" allowClear onChange={handlePronounChange}>
							<Option value="Male">Male</Option>
							<Option value="Female">Female</Option>
						</Select>
					</Form.Item>
					{"from"}
					<Form.Item name="location">
						<Input placeholder="Location" className='min-w-[200px]' />
					</Form.Item>
					{"who was referred for an assessment by"}
					<Form.Item name="source">
						<Input placeholder="Referral Source" />
					</Form.Item>
					{"."}
				</Space>
				<div className='mt-1'>{constants.ReasonForCall}: {reasonforcallabel || ''}</div>
				<div className='mt-1'>{constants.Email}: {props?.location?.state?.answers?.email || ''}</div>
				<div className='mt-1'>{constants.phone}: {props?.location?.state?.answers?.client_contact_number || ''}</div>
				<div className='mt-1'>{constants.ServiceText}: {props?.location?.state?.answers?.service === "1" ? `<h3>${props?.location?.state?.first_name} ${constants.ServiceTextYes}` : `<h3>${props?.location?.state?.first_name} ${constants.ServiceTextNo}`}</div>
				<div className='mt-1'>{constants.EmergencyContactName}: {props?.location?.state?.answers?.emergency_contact_name || ''}</div>
				<div className='mt-1'>{constants.RelationtoRecipient}: {relationtoRecipientlabel || ""}</div>
				<div className='mt-1'>{constants.IsSignedConsentForm}: {props?.location?.state?.answers?.is_signed_consentform === "1" ? `<h3>${props?.location?.state?.first_name} ${constants.IsSignedConsentFormYes}` : `<h3>${props?.location?.state?.first_name} ${constants.IsSignedConsentFormNo}`}</div>
			</>
		)
	}

	const drugsForm = () => {
		return (
			<div className='flex flex-col'>
				{noteTypeValue !== "3" && (<Space direction="vertical" className="mb-3">
					{constants.Substances.map((substance) => (
						<Form.Item key={substance.key} className="mb-3">
							<div className='h-[36px] flex items-center'>
								<Checkbox
									onChange={(e) => handleCheckboxSubChange(substance.key, e.target.checked)}
									checked={selectedSubstances?.[substance.key]?.checked ? true : false}
								>
									<p className='text-[14px]'><b>{substance.substances}</b></p>
								</Checkbox>
								{selectedSubstances?.[substance.key]?.checked && substance.key !== "not_applicable" && substance.key !== "other" ? (
									<>
										<b className='text-[14px] font-normal mr-2'>{"at age"}</b>
										<InputNumber
											value={selectedSubstances?.[substance.key]?.age ? selectedSubstances?.[substance.key]?.age : ""}
											placeholder="Enter age"
											min={1}
											style={{ width: 100 }}
											onChange={(value) => handleAgeChange(substance.key, value)}
										/>
									</>
								) : null}
							</div>
							{
								substance.key === "gambling" && selectedSubstances?.[substance.key]?.checked || substance.key === "other" && selectedSubstances?.[substance.key]?.checked ?
									substance.key === "gambling" && selectedSubstances?.[substance.key]?.checked ?
										<>
											{
												substance.gamblingOptions.map((val, index) => {
													return <div className="ml-5 mt-2">
														<Checkbox
															onChange={(e) => handleCheckboxSubChange(substance.key, e.target.checked, val.value)}
															checked={selectedSubstances?.[substance.key][val.value]?.checked ? true : false}
														>
															<p className='text-[14px]'><b>{val?.label}</b></p>
														</Checkbox>
													</div>
												})
											}
											<p className='text-[14px] ml-5 mt-1'>Type of gambling:</p>
											<TextArea
												className="mt-2 ml-5"
												value={selectedSubstances?.[substance.key]?.textValue}
												onChange={(value) => handleGamblingChange(substance.key, value.target.value)}
												rows={4}
											/>
										</>
										:
										<TextArea
											className="mt-2 ml-5"
											value={selectedSubstances?.[substance.key]?.textValue}
											onChange={(value) => handleGamblingChange(substance.key, value.target.value)}
											rows={4}
										/>
									:
									<>
										<p className="text-blue-500 text-[14px]	ml-5">{substance.key === "gambling" || substance.key === "other" || substance.key === "not_applicable" ? "" : "-"}{constants.SubstancesAliases[substance.key]}</p>
										{
											substance.key === "nicotine_vapes" && selectedSubstances?.[substance.key]?.checked ?
												substance.nicotineOptions.map((val, index) => {
													return <div className="ml-5 mt-2">
														<Checkbox
															onChange={(e) => handleCheckboxSubChange(substance.key, e.target.checked, val.value)}
															checked={selectedSubstances?.[substance.key][val.value]?.checked ? true : false}
														>
															<p className='text-[14px]'><b>{val?.label}</b></p>
														</Checkbox>
														{selectedSubstances?.[substance.key][val.value]?.checked ? (
															<>
																<b className='text-[14px] font-normal mr-2'>{"at age"}</b>
																<InputNumber
																	value={selectedSubstances?.[substance.key][val.value]?.age ? selectedSubstances?.[substance.key][val.value]?.age : ""}
																	placeholder="Enter age"
																	min={1}
																	style={{ width: 100 }}
																	onChange={(age) => handleAgeChange(substance.key, age, val.value)}
																/>
															</>
														) : null}
													</div>
												}) :
												null
										}
									</>
							}
						</Form.Item>
					))}
				</Space>)}
				<Space wrap align="center" className="mb-3">
					{noteTypeValue !== "3" ? `, gradually increasing amounts to achieve the desired effect over a longer period of time than intended, despite problems in the past 12 months with` : `However, ${lowPronoun} reported problems in the past 12 months with`}
				</Space>
				<Space direction="vertical" className="mb-5">
					{constants.Reasons.map((reason) => (
						<Form.Item key={reason.key}>
							<Checkbox
								onChange={(e) => handleCheckboxReaChange(reason.key, e.target.checked)}
								checked={selectedReasons[reason.key]?.checked ? true : false}
							>
								<p className="text-[14px]">{reason.reason}</p>
							</Checkbox>
							{selectedReasons[reason.key]?.checked && !Array.isArray(constants.ReasonValues[reason.key]) && (
								<Input
									defaultValue={selectedReasons[reason.key]?.cause || constants.ReasonValues[reason.key]}
									value={selectedReasons[reason.key]?.cause ? selectedReasons[reason.key]?.cause : ""}
									placeholder="Enter cause"
									style={{ width: 600 }}
									onChange={(e) => handleCauseChange(reason.key, e.target.value)}
								/>
							)}
							{selectedReasons[reason.key]?.checked && Array.isArray(constants.ReasonValues[reason.key]) && (
								<Space direction="vertical">
									{constants.ReasonValues[reason.key].map((cause) => (
										<Checkbox
											key={cause}
											checked={selectedReasons[reason.key]?.causes?.[cause] || false}
											onChange={(e) => handleNestedCauseChange(reason.key, cause, e.target.checked)}
										>
											<p className="text-[14px] font-normal">{cause}</p>
										</Checkbox>
									))}
								</Space>
							)}
						</Form.Item>
					))}
				</Space>

				{noteTypeValue !== "3" ? <>
					<Space wrap align="center" className="mb-3">
						{`, caused or exacerbated by use of substances, including reduced involvement in social activities. ${pronoun} reported several attempts to`}
					</Space>
					<Space wrap align="center" className="mb-7">
						{constants.CageScreeningPre.map((cage) => (
							<Form.Item key={cage.key} >
								<Checkbox
									onChange={(e) => handleCheckboxAttemptChange(cage.key, e.target.checked)}
									checked={selectedAttempts?.[cage.key] ? selectedAttempts[cage.key].checked : false || false}
								>
									<p>{cage?.label}</p>
								</Checkbox>
							</Form.Item>
						))}
					</Space>
					<Space wrap align="center" className="mb-3">
						<Form.Item name={"first_name"}>
							<Input placeholder={constants.FirstName} />
						</Form.Item>
						<Form.Item name="drug_1" >
							<Select placeholder="denies/reports" allowClear onChange={handleDrug1Change}>
								<Option value="denies any">denies</Option>
								<Option value="reports">reports</Option>
							</Select>
						</Form.Item>
						{`gambling activity`}
						{!isDrug1Selected && (<>
							{`and`}
							<Form.Item name="drug_2">
								<Select title={`has felt the need to bet more and more money, and has lied to people about how much ${lowPronoun} gamble${past}`} placeholder={`has felt the need to bet more and more money, and has lied to people about how much ${lowPronoun} gamble${past}`} mode="tags" style={{ minWidth: '400px', }}>
									<Option value="has felt the need to bet more and more money">has felt the need to bet more and more money</Option>
									<Option value={`has lied to people about how much ${lowPronoun} gamble${past}.`}>has lied to people about how much {lowPronoun} gamble{past}</Option>
								</Select>
							</Form.Item>
						</>)}
						{"."}
					</Space>
					<Space wrap align="center" className="mb-3">
						<Form.Item name="drug_3">
							<Select placeholder="Denies/Reports" allowClear>
								<Option value="Denies">Denies</Option>
								<Option value="Reports">Reports</Option>
							</Select>
						</Form.Item>
						{`family of origin`}
						<Form.Item name="drug_11">
							<Select placeholder="substance use/gambling" mode="tags" style={{ minWidth: '200px', }}>
								<Option value="substance use">substance use</Option>
								<Option value="gambling">gambling</Option>
							</Select>
						</Form.Item>
						{`problems.`}
					</Space>
					<Space wrap align="center" className="mb-3">
						{`Client reports ${lowPronoun} has`}
						<Form.Item name="drug_4">
							<Select placeholder="been/never been" allowClear onChange={handleDrug4Change}>
								<Option value="been">been</Option>
								<Option value="never been">never been</Option>
							</Select>
						</Form.Item>
						{`previously treated for addiction`}
						{!isDrug4Selected && <>
							{`at`}
							<Form.Item name={"drug_5"}>
								<Input placeholder={"Enter Rehab"} />
							</Form.Item>
							{`and with`}
							<Form.Item name={"drug_6"}>
								<Input placeholder={"Enter Therapist"} />
							</Form.Item>
						</>}
						{`;\u00A0\u00A0 has`}
						<Form.Item name="drug_7">
							<Select placeholder="no/some" allowClear>
								<Option value="no">no</Option>
								<Option value="some">some</Option>
							</Select>
						</Form.Item>
						{`recovering friends;`}
						<Form.Item name="drug_8">
							<Select placeholder="no/some" allowClear>
								<Option value="no">no</Option>
								<Option value="some">some</Option>
							</Select>
						</Form.Item>
						{`prior 12-step program experience and longest period of abstinence is`}
						<Form.Item name={"drug_9"}>
							<Input placeholder={"days/months/years"} />
						</Form.Item>
						{"."}
					</Space>
				</> : null}
			</div>
		)
	};

	const presentingProblemForm = () => {
		return (
			<>
				<div className='mt-5 mb-4 italic'><b><u>{noteTypeValue === "1" ? "Presenting Problem/Addiction/Recovery History:" : "Presenting Problem:"}</u></b></div>
				<Space wrap align="center" className="mb-3">
					{noteTypeValue === "1" && <>
						{"Client was seen"}
						<Form.Item name={"problem_1"}>
							<Select placeholder="online/in-person" allowClear>
								<Option value="online">online</Option>
								<Option value="in-person">in-person</Option>
							</Select>
						</Form.Item>
						{`and during ${lowPossPronoun} assessment, outlined ${lowPossPronoun} substance abuse history.`}
						<Form.Item name={"first_name"}>
							<Input placeholder={constants.FirstName} />
						</Form.Item>
						{`reported that ${lowPronoun} had begun to use`}
					</>
					}
					{noteTypeValue === "3" && <>
						{`Client was seen`}
						<Form.Item name={"problem_1"}>
							<Select placeholder="online/in-person" allowClear>
								<Option value="online">online</Option>
								<Option value="in-person">in-person</Option>
							</Select>
						</Form.Item>
						{`, and during ${lowPossPronoun} assessment, stated concerns about ${lowPossPronoun} emotional status`}
						{`and reported feeling angry, anxious, and depressed within the past 12 months.`}
					</>
					}
					{noteTypeValue === "2" && <>
						{`Client was seen`}
						<Form.Item name={"problem_1"}>
							<Select placeholder="online/in-person" allowClear>
								<Option value="online">online</Option>
								<Option value="in-person">in-person</Option>
							</Select>
						</Form.Item>
						{`, and during ${lowPossPronoun} assessment, stated concerns about ${lowPossPronoun} family member`}
						<Form.Item name={"problem_2"}>
							<Input placeholder={"Name or Relation"} />
						</Form.Item>
						{"'s"}
						<Form.Item name="disorder1">
							{custom_select(false, "", "tags", disorder, addDisorder, newDisorder, (e) => setNewDisorder(e.target.value), disorderInputRef, { minWidth: '400px', })}
						</Form.Item>
						{"."}
						{`${pronoun} report${past} feeling angry, anxious, and depressed about`}
						<Form.Item name={"problem_2"}>
							<Input placeholder={"Name or Relation"} />
						</Form.Item>
						{"'s"}
						<Form.Item name="disorder2">
							{custom_select(false, "", "tags", disorder, addDisorder, newDisorder, (e) => setNewDisorder(e.target.value), disorderInputRef, { minWidth: '400px', })}
						</Form.Item>
						{`and report${past} several attempts to help`}
						<Form.Item name={"problem_2"}>
							<Input placeholder={"Name or Relation"} />
						</Form.Item>
						{'abstain within the past'}
						<Form.Item name={"problem_3"}>
							<Input placeholder={"days/months/years"} />
						</Form.Item>
						{`and feel${past} frustrated at ${lowPossPronoun} inability do so.`}

					</>
					}
				</Space>
				<div className="w-full block mb-2">
					<Form.Item name={"presenting_problem_text"}>
						<TextArea className="w-full" rows={3} />
					</Form.Item>
				</div>
				{noteTypeValue === "1" ? drugsForm() : null}
			</>
		)
	}

	const addictionForm = () => {
		return (
			<>
				<div className='mt-5 mb-4 italic'><b><u>Addiction/Recovery History:</u></b></div>
				<Space wrap align="center" className="mb-3">
					{pronoun}
					<Form.Item name="addiction_1">
						<Select placeholder="denied/reported" allowClear>
							<Option value="denied any">denied</Option>
							<Option value="reported">reported</Option>
						</Select>
					</Form.Item>
					{`personal history of substance abuse (other than occasional`}
					<Form.Item name="addiction_3">
						<Select placeholder="social/religious" mode='tags' style={{ minWidth: '150px', }}>
							<Option value="social">social</Option>
							<Option value="religious">religious</Option>
						</Select>
					</Form.Item>
					{`use of alcohol).`}
					<Form.Item name="addiction_2">
						<Select placeholder="Denies/Reports" allowClear>
							<Option value="Denies any">Denies</Option>
							<Option value="Reports">Reports</Option>
						</Select>
					</Form.Item>

					{`gambling activity.`}
					{noteTypeValue !== "3" && (
						<>
							{`${pronoun} stated that, to the best ${lowPossPronoun} recollection, ${lowPossPronoun} family member`}
							<Form.Item name="problem_2">
								<Input placeholder="Name or Relation" />
							</Form.Item>
							{`had begun to use`}
						</>
					)}
				</Space>
				{drugsForm()}
			</>
		)
	}

	const emotionalForm = () => {
		return (
			<>
				<div className='mt-5 mb-4 italic'><b><u>Mental/Emotional Health:</u></b></div>
				<Space wrap align="center" className="mb-3">
					{"Client"}
					<Form.Item name="emotional_1">
						<Select placeholder="denies/reports" allowClear onChange={handleEmotional1Change}>
							<Option value="denies">denies</Option>
							<Option value="reports">reports</Option>
						</Select>
					</Form.Item>
					{"MH history"}
					{!isEmotional1Selected && (<>{", was diagnosed with"}
						<Form.Item name="emotional_2">
							{custom_select(false, "anxiety/depression/mood disorder/bipolar disorder", 'tags', mentalD, addMentalD, newMentalD, (e) => setNewMentalD(e.target.value), mentalDInputRef, { minWidth: '200px', })}
						</Form.Item>
						{"and"}
						<Form.Item name="emotional_10">
							<Select placeholder="received/never received" allowClear onChange={handleEmotional10Change}>
								<Option value="received">received</Option>
								<Option value="never received">never received</Option>
							</Select>
						</Form.Item>
						{"mental health treatment"}
						{!isEmotional10Selected && (<>
							{"from"}
							<Form.Item name={"emotional_3"}>
								<Input placeholder={"Therapist"} />
							</Form.Item>
						</>)}
						{"and"}
						<Form.Item name="emotional_11">
							<Select placeholder="was/was not" allowClear onChange={handleEmotional11Change}>
								<Option value="was">was</Option>
								<Option value="was not">was not</Option>
							</Select>
						</Form.Item>
						{"hospitalized for mental illness"}
						{!isEmotional11Selected && (<Form.Item name={"emotional_4"}>
							<Input placeholder={"mental illness"} />
						</Form.Item>)}
						{"and is on"}
						<Form.Item name="emotional_12">
							<Select placeholder="medication/no medications" allowClear onChange={handleEmotional12Change}>
								<Option value="medication">medication</Option>
								<Option value="no medications">no medications</Option>
							</Select>
						</Form.Item>
						{!isEmotional12Selected && (<Form.Item name={"emotional_5"}>
							<Input placeholder={"medication"} />
						</Form.Item>)}
					</>)}
					{".\u00A0\u00A0"}
				</Space>
				<Space wrap align="center" className="mb-3">
					<Form.Item name={"first_name"}>
						<Input placeholder={constants.FirstName} />
					</Form.Item>
					<Form.Item name="emotional_9">
						<Select placeholder="denies/reports" allowClear onChange={handleEmotional9Change}>
							<Option value="denies">denies</Option>
							<Option value="reports">reports</Option>
						</Select>
					</Form.Item>
					{"a history of SI (Suicidal Ideation) or HI (Homicidal Ideation)."}
					{!isEmotional9Selected && (<Form.Item name={"emotional_6"}>
						<Input placeholder="Details" />
					</Form.Item>)}
				</Space>
				{noteTypeValue !== "3" && (
					noteTypeValue !== "1" ? (
						<>
							<Space wrap align="center" className="mb-3">
								{`However, ${lowPronoun} reports feeling angry, anxious and depressed about`}
								<Form.Item name={"emotional_7"}>
									<Input placeholder={"Name or Relation"} />
								</Form.Item>
								{`’s`}
								<Form.Item name="emotional_disorder">
									{custom_select(false, "", "tags", disorder, addDisorder, newDisorder, (e) => setNewDisorder(e.target.value), disorderInputRef, { minWidth: '400px', })}
								</Form.Item>
								{`including symptoms of`}
								<Form.Item name="emotional_8">
									{custom_select(false, "symptoms", "tags", symptoms, addSymptoms, newSymptoms, (e) => setNewSymptoms(e.target.value), symptomsInputRef, { minWidth: '200px', })}
								</Form.Item>
								{`.`}
							</Space>
							<Space wrap align="center" className="mb-3">
								{`${pronoun} reported that this has led to problems at home (arguments and differences of opinion).`}
							</Space>
						</>
					) : (<Space wrap align="center" className="mb-3">
						{`${pronoun} reported that in the last 12 months, ${lowPronoun} has experienced symptoms of severe distress like`}
						<Form.Item name="emotional_8">
							{custom_select(false, "symptoms", "tags", symptoms, addSymptoms, newSymptoms, (e) => setNewSymptoms(e.target.value), symptomsInputRef, { minWidth: '200px', })}
						</Form.Item>
						{", which has led to interference and problems in daily life."}
					</Space>))}
			</>
		)
	}

	const medicalForm = () => {
		return (
			<>
				<div className='mt-5 mb-4 italic'><b><u>Medical History:</u></b></div>
				<Space wrap align="center" className="mb-6">
					<Form.Item name={"first_name"}>
						<Input placeholder={constants.FirstName} />
					</Form.Item>
					{"identifies as"}
					<Form.Item
						name="sexula_orientation"
					>
						<Select placeholder={constants.SexualOrientation} allowClear>
							{
								constants.SexualOrientationOption.map((val) => {
									return <Option key={val.value} value={val.value}>{val?.label}</Option>
								})
							}
						</Select>
					</Form.Item>
					{"and is in"}
					<Form.Item name="medical_2">
						<Select placeholder="good/poor" allowClear>
							<Option value="good">good</Option>
							<Option value="fair">Fair</Option>
							<Option value="poor">poor</Option>
						</Select>
					</Form.Item>
					{"health , has a primary care physician and last physical was on:"}
					<Form.Item name={"medical_3"}>
						<Input placeholder={"date"} />
					</Form.Item>
					{". Reports"}
					<Form.Item name="medical_4">
						<Select placeholder="Allergies/no Allergies" allowClear onChange={handleMedical4Change}>
							<Option value="Allergies">Allergies</Option>
							<Option value="no Allergies">no Allergies</Option>
						</Select>
					</Form.Item>
					{isMedical4Selected && (
						<Form.Item name={"medical_5"}>
							<Input placeholder={"allergies"} />
						</Form.Item>
					)}
					{"and"}
					<Form.Item name="medical_6">
						<Select placeholder="illnesses/no illnesses" allowClear onChange={handleMedical6Change}>
							<Option value="illnesses/disease">illnesses/diseases</Option>
							<Option value="no illnesses/disease">no illnesses/diseases</Option>
						</Select>
					</Form.Item>
					{isMedical6Selected && (
						<Form.Item name={"medical_7"}>
							<Input placeholder={"illnesses/disease"} />
						</Form.Item>
					)}
					{". Currently taking"}
					<Form.Item name="medical_8">
						<Select placeholder="no/medications/OTCs" allowClear onChange={handleMedical8Change}>
							<Option value="medications/OTCs">medications/OTCs</Option>
							<Option value="no medications/OTCs">no medications/OTCs</Option>
						</Select>
					</Form.Item>
					{isMedical8Selected && (
						<Form.Item name={"medical_9"}>
							<Input placeholder={"medications/OTCs"} />
						</Form.Item>
					)}
					{". Reports eating"}
					<Form.Item name="medical_10">
						<Select placeholder={constants.DietaryHabbitsPlaceHolder} mode="multiple" style={{ minWidth: '200px', }}>
							{
								constants.DietaryHabbits.map((diet) => {
									return <Option key={diet.key} value={diet.key}>{diet?.label}</Option>
								})
							}
						</Select>
					</Form.Item>
					{"."}
				</Space>
				<Col xs={24} sm={24} lg={24}><div className="font-medium mb-2 text-[16px]">{constants.MentalHealthTxt}</div></Col>
				<Checkbox.Group onChange={handleCheckboxMentalHealthOption} value={selectedMentalHealthOption}>
					<Row gutter={[12, 12]}>
						{constants.MentalHealthOptions.map((value) => (
							<Col xs={24} sm={12} lg={8} key={value.value}>
								<Checkbox value={value.value}>
									<p className='text-[14px]'>{value?.label}</p>
								</Checkbox>
							</Col>
						))}
					</Row>
				</Checkbox.Group>
			</>
		)
	}

	const familyForm = () => {
		return (
			<>
				<div className='mt-5 mb-4 italic'><b><u>Family/General:</u></b></div>
				<Space wrap align="center" className="mb-3">
					{"Client is the"}
					<Form.Item name={"family_1"}>
						{custom_select(true, "birth order", null, birthOrder, addBirthOrder, newBirthOrder, (e) => setNewBirthOrder(e.target.value), birthOrderInputRef, { minWidth: '200px', }, handleFamily1Change)}
					</Form.Item>
					{isFamily1Selected ? "child and is" : (<>
						{'of'}
						<Form.Item name={"family_2"}>
							<InputNumber min='2'
								placeholder={"total"}
								formatter={(value) => (value === 0 ? "no" : value)}
								parser={(value) => value === "no" ? 0 : Number(value)}
							/>
						</Form.Item>
						{"children and is"}
					</>)}
					<Form.Item name="family_3">
						{custom_select(true, "living alone/with spouse/partner & children/joint family", null, living, addLiving, newLiving, (e) => setNewLiving(e.target.value), livingInputRef)}
					</Form.Item>
					{"."}
				</Space>

				<Space wrap align="center" className="mb-3">
					{`${pronoun} reports that ${pronoun} is`}
					<Form.Item name="maritalstatus">
						<Select placeholder={constants.MaritalStatus} allowClear >
							{constants.MaritalStatusOption.map((val) => {
								return <Option key={val.value} value={val.value}>{val?.label}</Option>
							})}
						</Select>
					</Form.Item>
					{`${pronoun} reports`}
					<Form.Item name="family_4">
						<Select placeholder="fair/good/poor" allowClear>
							<Option value="fair">fair</Option>
							<Option value="good">good</Option>
							<Option value="poor">poor</Option>
						</Select>
					</Form.Item>
					{`relations with family of origin (parents)`}
					<Form.Item name="mother_name">
						<Input placeholder="Mother name" />
					</Form.Item>
					<Form.Item name="father_name">
						<Input placeholder="Father Name" />
					</Form.Item>
					{`(siblings)`}
					<Form.Item name="sibling_names">
						<Input placeholder="Name of the siblings" />
					</Form.Item>
					<Form.Item name={"sibling_ages"}>
						<Input placeholder={"sibling's ages"} />
					</Form.Item>
					{!isFamily1Selected && (<>
						{`and`}
						<Form.Item name="family_5">
							<Select placeholder="fair/good/poor" allowClear>
								<Option value="fair">fair</Option>
								<Option value="good">good</Option>
								<Option value="poor">poor</Option>
							</Select>
						</Form.Item>
						{`relations with nuclear family (spouse/partner)`}
						<Form.Item name="spouse_name">
							<Input placeholder="Name of the spouse/partner" />
						</Form.Item>
					</>)}
					{`and`}
					<Form.Item name="family_6">
						<Select placeholder="has/has no" allowClear onChange={handleFamily6Change}>
							<Option value="has">has</Option>
							<Option value="has no">has no</Option>
						</Select>
					</Form.Item>
					{`children`}
					{!isFamily6Selected ? (<>
						<Form.Item name="children_name">
							<Input placeholder="Name of the children's" />
						</Form.Item>
						<Form.Item name={"family_7"}>
							<Input placeholder={"children's ages"} />
						</Form.Item>
					</>) : null}
					{"."}
				</Space>
				<Space wrap align="center" className="mb-6">
					<Form.Item name={"first_name"}>
						<Input placeholder={constants.FirstName} />
					</Form.Item>
					{"reports"}
					<Form.Item name="family_8">
						<Select placeholder="no/current" allowClear onChange={handleFamily8Change}>
							<Option value="no">no</Option>
							<Option value="current">current</Option>
						</Select>
					</Form.Item>
					{"legal issues"}
					{isFamily8Selected && (
						<Form.Item name={"family_9"}>
							<Input placeholder={"legal issues"} />
						</Form.Item>
					)}
					{";\u00A0\u00A0 has completed"}
					<Form.Item name={"family_10"}>
						<Select placeholder={"Education"} allowClear onChange={handleEducationChange}>
							{constants.EducationOptions.map((val) => {
								return <Option key={val.value} value={val.value}>{val?.label}</Option>
							})}
						</Select>
					</Form.Item>
					{
						showEducationDetails ?
							<Form.Item
								name={"education_details"}
							>
								<Input type="text" />
							</Form.Item> : null
					}
					{"and"}
					<Form.Item name="family_11">
						<Select placeholder={"Occupation"} allowClear>
							{constants.OccupationOptions.map((val) => {
								return <Option key={val.value} value={val.value}>{val?.label}</Option>
							})}
						</Select>
					</Form.Item>
					{isFamily11Selected && (
						<Form.Item name={"family_12"}>
							<Input placeholder={"profession"} />
						</Form.Item>
					)}
					{`. ${pronoun} is`}
					<Form.Item name="family_13">
						<Select placeholder="active/inactive" allowClear>
							<Option value="active">active</Option>
							<Option value="inactive">inactive</Option>
						</Select>
					</Form.Item>
					{'and'}
					<Form.Item name="family_14">
						<Select placeholder="does/does no" allowClear onChange={handleFamily14Change}>
							<Option value="does">does</Option>
							<Option value="does no">does no</Option>
						</Select>
					</Form.Item>
					{'exercise, hobbies, recreational interests, sports, leisure activities'}
					{!isFamily14Selected && (
						<>
							{'like'}
							<Form.Item name="family_15">
								<Input placeholder="activities" />
							</Form.Item>
						</>
					)}
					{`in ${lowPossPronoun} free time.`}
				</Space>
			</>
		)
	}

	// Main Forms
	const formData = () => {
		return (
			<div className='text-[14px] mb-4 w-full'>
				<div className='text-lg mb-4'><b><u>{notesHeader[0]}</u></b></div>
				{introForm()}
				{presentingProblemForm()}
				{noteTypeValue !== "1" ? addictionForm() : null}
				{emotionalForm()}
				{medicalForm()}
				{familyForm()}
			</div>
		)
	}

	const formAssessment = () => {
		return (<><Divider />
			<div className='mb-6'>
				<div className="text-lg mb-4"><b><u>{notesHeader[1]}</u></b></div>
				<div className="flex flex-wrap gap-2 text-[14px]">
					<Form.Item name="first_name">
						<Input placeholder={constants.FirstName} />
					</Form.Item>
					<span>presented as well-groomed and reported performing daily functions regularly.</span>
					<span>{pronoun}</span>
					<span>{beVerb}</span>
					<Form.Item name="assess_1">
						<Select placeholder="ambivalent/motivated" allowClear>
							<Option value="ambivalent">ambivalent</Option>
							<Option value="motivated">motivated</Option>
						</Select>
					</Form.Item>
					<span>about coaching and present as</span>
					<Form.Item name="orientation_to_change">
						<Select placeholder="Select orientation" allowClear>
							{constants.orientationOptions.map((option) => (
								<Option key={option.value} value={option.value}>{option?.label}</Option>
							))}
						</Select>
					</Form.Item>
					<span>in {lowPossPronoun} approach to change. Based on the</span>
					<Form.Item name="assess_2">
						{custom_select(false, "CAGE/MMMH", "tags", assessment, addAssessment, newAssessment, (e) => setNewAssessment(e.target.value), assessmentInputRef, { minWidth: '200px' })}
					</Form.Item>
					<span>assessment screening instruments, {lowPronoun}</span>
					<Form.Item name="assess_3">
						<Select placeholder="appears/does not appear" allowClear>
							<Option value="appears">appears</Option>
							<Option value="does not appear">does not appear</Option>
						</Select>
					</Form.Item>
					<span>to meet ICD criteria for</span>

					{isSelectedDisorderes && <Form.Item name="assesment_disorder" >
						{custom_select(false, "Select assessed disorder", "tags", disorder, addDisorder, newDisorder, (e) => setNewDisorder(e.target.value), disorderInputRef, { minWidth: '400px' }, (selected) => setIsSelectedDisorderes(!!selected?.length))}
					</Form.Item>}

					{Object.entries(diagnosisData).map(([key, values]) => {
						if (!Array.isArray(values) || values.length === 0) return null;

						const label = Object.keys(diagnosisTypeMap).find(k => diagnosisTypeMap[k].name === key);
						const options = diagnosisTypeMap[label]?.options || [];

						return (
							<div key={key} className='mb-3' >
								<strong>{label}: </strong>
								<Space wrap>
									{values.map(val => {
										const optionLabel = options.find(o => o.value === val)?.label || val;
										return <Tag key={val}>{optionLabel}</Tag>;
									})}
								</Space>
							</div>
						);
					})}

					<span>and is</span>
					<Form.Item name="assess_4">
						<Select placeholder="appropriate/not appropriate" allowClear>
							<Option value="appropriate">appropriate</Option>
							<Option value="not appropriate">not appropriate</Option>
						</Select>
					</Form.Item>
					<span>for coaching/counseling.</span>
					{/* <Form.Item name="assignto">
						<Select
							placeholder={constants.AssignedTo}
							showSearch
							allowClear
							filterOption={selectFilterOption}
							className='min-w-[200px]'
						>
							{
								listAssociates?.map((associate) => <Option value={associate?.firstname + ' ' + associate?.lastname} key={associate?.client_id}>{associate?.firstname + ' ' + associate?.lastname}</Option>)
							}
						</Select>
					</Form.Item> */}
				</div>
				<Divider />
				<Row gutter={[16, 16]}>
					<Col sm={12}>
						<Form.Item label="Diagnosis Type" >
							<Select
								placeholder="Select Diagnosis Type"
								onChange={(value) => setSelectedDiagnosisType(value)}
								value={selectedDiagnosisType}
								allowClear
							>
								{Object.keys(diagnosisTypeMap).map((label) => (
									<Select.Option key={label} value={label}>
										{label}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
					{selectedDiagnosisType && (<Col sm={12}>
						<Form.Item label="Disorders">
							<Select
								mode="tags"
								placeholder="Select disorders"
								value={diagnosisData[diagnosisTypeMap[selectedDiagnosisType]?.name] || []}
								onChange={(values) => {
									setDiagnosisData((prev) => ({
										...prev,
										[diagnosisTypeMap[selectedDiagnosisType]?.name]: values
									}));
								}}
								allowClear
								showSearch
								optionFilterProp="children"
							>
								{diagnosisTypeMap[selectedDiagnosisType].options.map((option) => (
									<Select.Option key={option.value} value={option.value}>
										{option.label}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
					)}
				</Row>

			</div>
		</>)
	};

	const handleRedirect = () => {
		if (adminClientValuefromSession?.clientId) {
			history.push("/view-client");
		} else {
			history.push("/view-enquiry");
		}
	};

	const handleBackClick = () => {
		if (history.length > 1) {
			history.goBack();
		} else {
			handleRedirect();
		}
	};

	const formPlan = () => {
		return (
			<>
				<Divider />
				<div className='text-lg mb-4'><b><u>{notesHeader[2]}</u></b></div>
				<Space wrap align="center" className='text-[14px]'>
					{`Client was informed that ${lowPronoun} ${beVerb} required to`}
					<Form.Item name="plan_2">
						<Select
							title="complete a medical or wellness checkup/detox/have a Psych assessment with Dr. Ashish Deshpande/sign and complete the Coaching Agreement and Payment process"
							placeholder="complete a medical or wellness checkup/detox/have a Psych assessment with Dr. Ashish Deshpande/sign and complete the Coaching Agreement and Payment process"
							mode="tags"
							style={{ minWidth: '400px', }}
						>
							<Option value="complete a medical or wellness checkup">complete a medical or wellness checkup</Option>
							<Option value="detox">detox</Option>
							<Option value="have a Psychiatric assessment with Dr. Ashish Deshpande">have a Psychiatric assessment with Dr. Ashish Deshpande</Option>
							<Option value="have a Psychiatric assessment with Dr. Priyanka Mahajan">have a Psychiatric assessment with Dr. Priyanka Mahajan</Option>
							<Option value="have an MCMI psychiatric test with Zainab Zhanjharya">have an MCMI psychiatric test with Zainab Zhanjharya</Option>
							<Option value="sign and complete the Coaching Agreement and Payment process">sign and complete the Coaching Agreement and Payment process</Option>
						</Select>
					</Form.Item>
					{`prior to the commencement of coaching.`}
					<Form.Item name={"first_name"}>
						<Input placeholder={constants.FirstName} />
					</Form.Item>
					{`said ${lowPronoun} would`}
					<Form.Item name="plan_1">
						<Select placeholder="complete the paperwork, await the appointment/consider options" allowClear>
							<Option value="complete the paperwork, await the appointment">complete the paperwork, await the appointment</Option>
							<Option value="consider options">consider options</Option>
						</Select>
					</Form.Item>
					{",\u00A0 and then call back"}.
				</Space>
			</>
		)
	};

	const handleEsign = () => {
		let formvalue = form.getFieldsValue();
		createNote(formvalue, "esign");
	};

	const EditorForm = () => {
		const noteValueRefs = noteValue?.map(() => React.createRef())
		// When we receive speech text, insert it into the active Quill editor
		const handleSpeechInput = (spokenText, index) => {
			if (index === null || !spokenText) return;
			const quill = noteValueRefs[index]?.current?.getEditor();
			if (!quill) return;
			// Get current cursor position or end of editor
			const cursorPosition = quill.getSelection()?.index ?? 0;
			// Process text: trim, remove extra spaces, ensure punctuation
			let processedText = spokenText.trim();
			// Remove multiple spaces inside the sentence
			processedText = processedText.replace(/\s{2,}/g, ' ');
			// Insert text at cursor position
			quill.insertText(cursorPosition, processedText + " ");
			// Move cursor after inserted text
			quill.setSelection(cursorPosition + processedText.length + 1);
		};

		const handleFocus = (index) => {
			const quill = noteValueRefs[index].current.getEditor();
			const selection = quill.getSelection();
			if (!selection || selection.length === 0) {
				quill.format('header', 3);
			}
		};

		return (
			<>
				{noteValue?.map((value, index) => (
					<div key={index}>
						<Space size={"middle"}>
							<div className='text-lg'><b><u>{notesHeader[index]}</u></b></div>
							<SpeechToTextButton
								index={index}
								isActive={activeEditorIndex === index}
								onSpeech={handleSpeechInput}
								onStart={(idx) => setActiveEditorIndex(idx)}
								onStop={() => setActiveEditorIndex(null)}
							/>
						</Space>
						<ReactQuill
							name={index}
							ref={noteValueRefs[index]}
							className={`admin-notes mb-2 ${index === 1 || index === 2 ? 'small-notes' : ''}`}
							theme="snow"
							onChange={(val) => onchangeNoteValue(val, index)}
							value={value}
							placeholder="Write your note here"
							onFocus={() => handleFocus(index)}
							onKeyPress={() => handleFocus(index)}
						/>
						{(index === 1) && (
							<Form.Item label="Assessment Behavior">
								<Select
									placeholder="Select assessment behavior"
									showSearch
									mode="multiple"
									optionFilterProp="children"
									value={assessmentBehavior}
									onChange={(value) => setAssessmentBehavior(value)}
									filterOption={(input, option) =>
										option?.children?.toLowerCase()?.includes(input.toLowerCase())
									}
								>
									{constants.AssessmentGroupNotesOptions.map((group, groupIndex) => (
										<Select.OptGroup key={groupIndex} label={group.topic}>
											{[...group.options]
												.sort((a, b) => a.localeCompare(b))
												.map((sentence, optionIndex) => (
													<Select.Option key={`${groupIndex}-${optionIndex}`} value={sentence}>
														{sentence}
													</Select.Option>
												))}
										</Select.OptGroup>
									))}
								</Select>
							</Form.Item>
						)}

						{(index === 2 && noteTypeValue === "8") && (
							<Form.Item label="Plan Options">
								<Radio.Group onChange={(e) => {setPlanValue(e.target.value); setIsPlanSelected(true);}} value={planValue}>
									{constants.PlanOption.map((opt) => (
										<Radio key={opt.label} value={opt.label}>
											{opt.label}
										</Radio>
									))}
								</Radio.Group>
							</Form.Item>
						)}
					</div>
				))}
				<div className='pb-3'>
					<Space>
						<Button className='bg-sky-800 text-white uppercase' onClick={hideModal}>{constants.Cancel}</Button>
						<Button className='bg-sky-800 text-white uppercase' onClick={() => createNote(null, "add")} >{constants.Save}</Button>
						<Popconfirm title="You will not be able to Edit after you Esign the Notes" onConfirm={handleEsign}>
							<Button className='bg-sky-800 text-white uppercase'>{constants.Esign}</Button>
						</Popconfirm>
					</Space>
				</div>
			</>
		)
	}

	const renderForm = () => {
		return (
			<>
				{formData()}
				{formAssessment()}
				{formPlan()}
			</>
		)
	};
	return (
		<div className='add-note'>
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">{props?.path === "/edit-note" ? constants.EditNote : props?.path === "/self-assessment-summary" ? constants.SelfAssessmentSummy : props?.path === "/edit-self-assessment-summary" ? constants.EditSelfAssessmentSummy : props?.path === "/pre-assessment-intake" ? constants.PreAssessmentSummy : props?.path === "/edit-pre-assessment-intake" ? constants.EditPreAssessmentSummy : constants.AddNote}</span>
			</div>
			{
				props?.path === "/self-assessment-summary" && loginType === "0" ? <div className='p-2 mb-3'></div> :
					<div className='bg-amber-100 text-base font-semibold p-2 mb-3'>
						<div className="container mx-auto">
							<Space size={'small'} wrap direction='vertical'>
								<span>
									{
										props?.path === "/edit-note" ? constants.EditNote :
											props?.path === "/self-assessment-summary" && loginType !== "0" ? constants.SelfAssessmentSummy :
												props?.path === "/pre-assessment-intake" ? constants.PreAssessmentSummy :
													props?.path === "/edit-pre-assessment-intake" ? constants.EditPreAssessmentSummy :
														props?.path === "/edit-self-assessment-summary" ? constants.EditSelfAssessmentSummy :
															constants.AddNote
									}
									{
										loginType !== "0" ?
											` - ${adminClientValuefromSession?.client_name ?
												adminClientValuefromSession?.client_name :
												""
											}${adminClientValuefromSession?.client_serial_number ?
												` (#${adminClientValuefromSession?.client_serial_number})`
												: ""
											}`
											:
											""
									}
								</span>
								<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={handleBackClick}>{constants.BackBtn}</Button>
							</Space>
						</div>
					</div>
			}
			<Spin spinning={loader} size="large">
				<div className='container mx-auto'>
					{/* {
						(props?.path !== "/self-assessment-summary" && props?.path !== "/pre-assessment-intake" && props?.path !== "/edit-pre-assessment-intake") ?
							<div className='flex justify-between items-center pl-3 py-2 pr-7'>
								<Radio.Group onChange={(e) => getForm(e.target.value)} value={noteTypeValue}>
									<Radio disabled={isNoteAnswered === false ? false : ["2", "4"].includes(noteTypeValue) ? false : true} value={"2"}>{constants.FamilyMember}</Radio>
									<Radio disabled={isNoteAnswered === false ? false : ["1", "4"].includes(noteTypeValue) ? false : true} value={"1"}>{constants.AddictsGamblers}</Radio>
									<Radio disabled={isNoteAnswered === false ? false : ["3", "4"].includes(noteTypeValue) ? false : true} value={"3"}>{constants.Emotional}</Radio>
									<Radio disabled={isNoteAnswered === false ? false : noteTypeValue === "0" ? false : true} value={"0"}>{constants.General}</Radio>
								</Radio.Group>
							</div>
							: null
					} */}
					{
						props?.path === "/add-note" ? <div className='text-lg ml-2 font-bold'>{constants.General}</div> : null
					}
					<div className="px-2 pb-2">
						{(loginType === "0" && props?.path === "/self-assessment-summary") && (
							<Card className='mb-5 text-center' >
								{constants.WelcomeSelfAssess}
							</Card>
						)}
						{
							props?.path === "/self-assessment-summary" ? (
								<span className='text-lg font-bold mb-2'>{constants.AssessmentTitle}</span>
							) : (props?.path === "/pre-assessment-intake" || props?.path === "/edit-pre-assessment-intake") ? (
								null
							) : (props?.location?.state?.notes_type === "8") ? (
								<div><b className='text-sm'>{constants.GroupProgressNotes}</b></div>
							)
								:
								(
									<div><b className='text-sm'></b></div>
								)
						}
						<div className='flex gap-5 flex-wrap justify-between'>
							{DOB(noteDate.month, handleNoteMonthChange, noteDate.date, handleNoteDayChange, noteDate.year, handleNoteYearChange, "Date", (props?.path !== "/self-assessment-summary" || props?.path !== "/pre-assessment-intake" || props?.path !== "/edit-pre-assessment-intake") ? false : true)}
							{
								(props?.path !== "/self-assessment-summary" && props?.path !== "/pre-assessment-intake" && props?.path !== "/edit-pre-assessment-intake" && props?.path !== "/edit-self-assessment-summary") ?
									<Space>
										<Checkbox onChange={(e) => onFollowUpChange(e.target.checked)} className="mb-6" checked={notefollowUp} disabled={props?.location?.state?.answers?.follow_up}> Follow-up </Checkbox>
										<Checkbox onChange={(e) => onSessionChange(e.target.checked)} className='mb-6' checked={sessionChecked} disabled={sessionChecked && props?.location?.state?.session}>Session</Checkbox>
									</Space>
									: null
							}
						</div>
						<Card>
							{
								props?.path === "/self-assessment-summary" || props?.path === "/edit-self-assessment-summary" ? (
									<EditableCheatSheet
										customSelect={custom_select}
										onSubmit={(value, type, _, cb) => createNote(value, type, 2, cb)}
										handlePronounChange={handlePronounChange}
										assessment={formAssessment}
										plan={formPlan}
										customRadio={custom_radio}
									/>
								) : props?.path === "/pre-assessment-intake" || props?.path === "/edit-pre-assessment-intake" ? (
									<PreAssess_Summary
										customSelect={custom_select}
										onSubmit={(value, type, _, cb) => createNote(value, type, 1, cb)}
										handlePronounChange={handlePronounChange}
										customRadio={custom_radio}
									/>
								) : noteTypeValue === "0" || noteTypeValue === "8" ? EditorForm() : (
									<Form
										layout="inline"
										form={form}
										onFinish={createNote}
										className='mb-10 text-black client-details'>
										{renderForm()}
										<div className='pt-3'>
											<Space>
												<Button className='bg-sky-800 text-white uppercase' onClick={hideModal}>{constants.Cancel}</Button>
												<Button className='bg-sky-800 text-white uppercase' htmlType='submit'>{constants.Save}</Button>
												<Popconfirm title="You will not be able to Edit after you Esign the Notes" onConfirm={handleEsign}>
													<Button className='bg-sky-800 text-white uppercase'>{constants.Esign}</Button>
												</Popconfirm>
											</Space>
										</div>
									</Form>
								)}
						</Card>
					</div>
				</div>
			</Spin>
		</div>
	);
};

export default AddNote;